import { CSSObject } from "@emotion/react";
import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Select, { SingleValue, MultiValue, StylesConfig, ActionMeta } from "react-select";
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Button as BootstrapButton } from 'react-bootstrap';
import { all_routes } from '../../router/all_routes';
import DealsDeailsModal from '../../../core/modals/deals_modal';
import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import { useDispatch, useSelector } from 'react-redux';
import { setActivityTogglePopup } from '../../../core/data/redux/commonSlice';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import CollapseHeader from '../../../core/common/collapse-header';
import { accountType, ascendingandDecending, selectRelatedToType, documentType, LocaleData, status, statusList, selectAssignType, selectTaskCategoryOptions, selectTaskStatusOptions, selectTaskPriorityOptions, ratingOptions } from '../../../core/common/selectoption/selectoption';
import { SelectWithImage2 } from '../../../core/common/selectWithImage2';
import { useParams } from 'react-router-dom';
import { createLogCall, deleteLogCall, viewMemberLogCall, updateLogCall, userList, detailLogCall, updateLogCallStatus, listLeadsOption, listContactsOptionn, listAccountsOption, listOpportunitiesOption } from "./logcall_api";
import { deleteProductFromOpportunity, syncOpportunityProductPrice, updateOpportunityProductDetail, getOpportunityProductDetail, getProductPriceBookDetail, addProductToOppotunity, getAllProductsBasedOnPriceBook, getOpportunityDetail, addPriceBook, updatePriceBookFromopportunity, getAllPricebooks, getAllContacts, updateSingleContactRole, getSingleContactRoleData, deleteContactRole, addContactRole, addQuote, getQuote, getTypePipeline, updateStatus } from './dealsAPI';
import { getOpportunities, addOpportunity, updateOpportunity, deleteOpportunity, getAllTags, getAccessibilityForOppor, updateAccessibilityForOppor, changeOwner, getOpportunitiesFilter } from "./dealsAPI";
import { createTask, deleteTask, viewMemberTasks, updateTask, detailTask } from "../leads/task_api";
import { createEvent, ViewMemberEvent, deleteEvent, getEventDetail, updateEvent } from "../leads/event_api";
import { getAllCompanies } from "../companies/companyAPI";
import ResponseModal from "../../../core/modals/response_modal";
import { getTagList } from "../tags/tagAPI";
import { userListByRole } from "../users/userAPI";
import ActivityList from "../activity";
import { ACTIVITY_TYPES } from "../activity/activityAPI";
import { Button, message } from "antd";
interface Quote {
  opportunityId: number;
  expiryDate: string;
  name: string;
  notes: string;
  discountRate: number;
  taxRate: number;
}
interface Event {
  id: number;
  uuid: string;
  subject: string;
  description: string;
  startTime: string;
  endTime: string;
}
interface QuoteList {
  version: number;
  name: string;
  fileUrl: string;
}
interface OpportunityDetail {
  id: number;
  uuid: string;
  accountId: number;
  accountName: string;
  name: string;
  probability: number;
  owner: string;
  ownerUuid: string;
  amount: number;
  dueDate: string;
  expectedCloseDate: string;
  followUpDate: string;
  source: string;
  priority: string;
  description: string;
  stageId: number;
  stageName: string;
  status: string;
  tags: { tagId: number; name: string }[];
  contactRoles: { id: number; uuid: string; contactId: number; contactName: string; role: string }[];
  opportunityProductResponses: { id: number; productId: string; productName: string; quantity: number; salePrice: number }[];
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  priceBookId: number;
  priceBookName: string;
}
interface EditOpportunityForm {
  id: number;
  memberId: number;
  name: string;
  accountId: number;
  stageId: number;
  status: string;
  amount: number;
  dueDate: string;
  expectedCloseDate: string;
  followUpDate: string;
  owner: string;
  ownerUuid: string;
  source: string;
  priority: string;
  description: string;
  probability: number;
  tags: Array<{
    tagId: number;
    name: string;
  }>;
}
interface ContactRoles {
  id: number;
  uuid: string;
  contactId: number;
  contactName: string;
  role: string;
}
interface OpportunityProduct {
  productPriceBookId: number;
  quantity: number;
  salePrice: number;
  description: string;
}
interface SelectedProductDetail extends OpportunityProduct {
  productName: string;
}
interface OpportunityProductResponseDetail {
  id: number;
  productId: number;
  productName: string;
  productCode: string;
  quantity: number;
  salePrice: number;
  description: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}
interface UpdateOpportunityProductDTO {
  quantity: number;
  salePrice: number;
  description: string;
}
interface Product {
  id: number;
  price: number;
  priceBookId: number;
  productCode: string;
  productId: number;
  productName: string;
}
interface Contact {
  contactId: number;
  contactName: string;
}
interface PriceBook {
  id: number;
  name: string;
}

interface Stage {
  id: number;
  name: string;
  order: number;
}
interface LogCallDataUpdate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType?: string;
  assignRecord?: number;
  targetType?: string;
  targetRecord?: number;
}
interface LogCallDataCreate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType: string;
  assignRecord: number;
  targetType: string;
  targetRecord: number;
  checkedCreateFollowingTask: boolean;
}
interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface Tag {
  tagId: number;
  name: string;
}
interface CampaignListDTO {
  campaignId: number;
  campaignName: string;
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface LogCall {
  id: number;
  uuid?: string;
  status: string;
  userCall?: string;
  callTime?: string;
  notes?: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}
interface Tasks {
  id: number;
  uuid: string;
  title: string;
  category: string;
  responsible: { uuid: string; username: string };
  startDate: string;
  endDate: string;
  targetType: string;
  assignType: string;
  priority: string;
  status: string;
  description?: string
}
interface CreateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface TagOption {
  value: number;
  label: string;
}
interface UpdateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface TaskDetailDTO {
  title: string;
  category: string;
  responsible: { uuid: string; username: string }
  startDate: string;
  endDate: string;
  assignTags: Array<{ id: number; uuid: string; name: string }>;
  priority: string;
  status: string;
  description: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}

interface CreateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface UpdateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface EventDetailDTO {
  subject: string;
  description: string;
  attendees: { id: number; name: string }[];
  location: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string }[];
  startTime: string;
  endTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}



const DealsDetails = () => {
  const [reloadActivity, setReloadActivity] = useState(false);
  const { uuid } = useParams();
  const [dealDetail, setDealDetail] = useState<OpportunityDetail | null>(null);
  const [error, setError] = useState("");
  const [value, setValue] = useState('Write a new comment, send your team notification by typing @ followed by their name');
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteProductFromOpportunityModal, setShowDeleteProductFromOpportunityModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const onChange = (e: any) => {
    setValue(e.target.value);
  }
  const [showEditLogCallModal, setShowEditLogCallModal] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = useState<SelectedProductDetail[]>([]);
  const [showProductDetailModal, setShowProductDetailModal] = useState(false);
  const [selectedContactRoles, setSelectedContactRoles] = useState<number[]>([]);
  const [logCallToDelete, setLogCallToDelete] = useState<{ id: number } | null>(null);
  const [showDeleteLogCallModal, setShowDeleteLogCallModal] = useState(false);
  const [selectedContactRole, setSelectedContactRole] = useState<ContactRoles | null>(null);
  const [opportunityProductDetail, setOpportunityProductDetail] = useState<OpportunityProductResponseDetail | null>(null);
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [listPriceBooks, setListPriceBooks] = useState<PriceBook[]>([]);
  const [selectedPriceBook, setSelectedPriceBook] = useState<{ value: number; label: string } | null>(null);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDeleteContactRoleId, setSelectedDeleteContactRoleId] = useState<number | null>(null);
  const [selectedOpportunityProductId, setSelectedOpportunityProductId] = useState<number | null>(null);
  const [selectedDeleteProductId, setSelectedDeleteProductId] = useState<number | null>(null);
  const [selectedLogCallId, setSelectedLogCallId] = useState<{ id: number } | null>(null);
  const [assignTaskOptions, setAssignTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>([]);
  const [listContactAssignType, setListContactAssignType] = useState<ContactlListDTO[]>([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<AccountListDTO[]>([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] = useState<OpportunityListDTO[]>([]);
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  const [logCalls, setLogCalls] = useState<LogCall[]>([]);
  const [tasks, setTasks] = useState<Tasks[]>([]);
  const [selectedTaskId, setSelectedTaskId] = useState<{ id: number } | null>(null);
  const [editingTask, setEditingTask] = useState<TaskDetailDTO | null>(null);
  const [taskToDelete, setTaskToDelete] = useState<{ id: number } | null>(null);
  const [assignTaskType, setAssignTaskType] = useState("");
  const [relatedTaskType, setSelectRelatedTaskType] = useState("");
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const customStyles: StylesConfig<{ value: string; label: string }, true> = {
    control: (provided: CSSObject): CSSObject => ({
      ...provided,
      minHeight: "48px",
      maxHeight: "auto",
      overflowY: "auto",
      flexWrap: "wrap",
    }),
    valueContainer: (provided: CSSObject): CSSObject => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "auto",
    }),
  };
  const [events, setEvents] = useState<Event[]>([]);
  const [eventDetail, setEventDetail] = useState<EventDetailDTO | null>(null);
  const [attendees, setAttendees] = useState<{ value: number; label: string }[]>([]);
  const [newEventData, setNewEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const [editEventData, setEditEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const attendeesOptions = listUserCall.map((user) => ({
    value: user.id,
    label: user.username,
  }));
  const selectedAttendees = attendeesOptions.filter(option =>
    editEventData.attendees.includes(option.value)
  );
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);
  const handleSelectAttendeesChange = (selectedOptions: any) => {
    setAttendees(selectedOptions);
    setNewEventData((prevData) => ({
      ...prevData,
      attendees: selectedOptions ? selectedOptions.map((option: { value: number }) => option.value) : [],
    }));
    setEditEventData({
      ...editEventData,
      attendees: selectedOptions.map((option: { value: number }) => Number(option.value)),
    });
  };


  const getNewEventData = (): CreateEventDTO => {
    return {
      subject: newEventData.subject,
      description: newEventData.description,
      attendees: newEventData.attendees,
      location: newEventData.location,
      startTime: newEventData.startTime
        ? new Date(
          new Date(newEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: newEventData.endTime
        ? new Date(
          new Date(newEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: newEventData.assignType,
      assigneeId: newEventData.assigneeId,
      targetType: newEventData.targetType,
      targetIds: newEventData.targetIds,
    };
  };
  const getEditEventData = (): UpdateEventDTO => {
    return {
      subject: editEventData.subject,
      description: editEventData.description,
      attendees: editEventData.attendees,
      location: editEventData.location,
      startTime: editEventData.startTime
        ? new Date(
          new Date(editEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: editEventData.endTime
        ? new Date(
          new Date(editEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: editEventData.assignType,
      assigneeId: editEventData.assigneeId,
      targetType: editEventData.targetType,
      targetIds: editEventData.targetIds,
    };
  };
  const handleCreateEvent = async () => {
    try {
      const newEvent = getNewEventData();
      const response = await createEvent(newEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event created successfully!" });
        fetchEvents();
        resetNewEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewEventForm = () => {
    setNewEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const resetEditEventForm = () => {
    setEditEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const fetchEvents = async () => {
    if (!dealDetail?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await ViewMemberEvent("OPPORTUNITY", dealDetail?.id);
      setEvents(response.data.data || []);
    } catch (err) {
      setError("Failed to load events.");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteEventClick = async (eventId: number) => {
    setSelectedEventId(eventId);
    setShowDeleteModal(true);
  }
  const handleDeleteEventConfirm = async () => {
    if (!selectedEventId) return;
    try {
      const response = await deleteEvent(selectedEventId);
      if (response.status === 200) {
        fetchEvents();
        setResponse({ status: "success", message: "Delete event successfully!" });
        setSelectedEventId(0);
      }
    } catch (error: any) {
      console.error("Failed to delete:", error);
      setResponse({ status: "error", message: error.response?.data?.message || "Failed to delete event." });
    } finally {
      setShowDeleteModal(false);
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const fetchSelectedEvent = async (id: number) => {
    try {
      const response = await getEventDetail(id);
      const eventData = response.data.data as EventDetailDTO;
      setEventDetail({
        ...eventData,
        attendees: eventData.attendees || [],
        assignee: eventData.assignee || []
      });
      setEditEventData({
        subject: eventData.subject || "",
        description: eventData.description || "",
        attendees: eventData.attendees?.map(att => att.id) || "",
        location: eventData.location || "",
        assignType: eventData.assignType || "",
        assigneeId: eventData.assignee?.map(ass => ass.id) || 0,
        targetType: eventData.targetType || "",
        targetIds: eventData.targets ? eventData.targets.id : 0,
        startTime: eventData.startTime || "",
        endTime: eventData.endTime || ""
      });
      console.log("EventDetailabcxyz: ", editEventData)
    } catch (err) {
      console.error("Error fetching event details:", err);
    }
  };
  const handleEditClickEvent = (id: number) => {
    setSelectedEventId(id);
    fetchSelectedEvent(id);
  }
  const handleUpdateEvent = async () => {
    if (!selectedEventId) {
      return;
    }
    try {
      const editEvent = getEditEventData();
      const response = await updateEvent(selectedEventId, editEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event updated successfully!" });
        fetchEvents();
        resetEditEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  /*Events*/
  const COLORS = ["pending", "info", "pink", "success", "danger", "warning"];
  const getStageColor = (index: number) => COLORS[index % COLORS.length];
  const [stages, setStages] = useState<{ label: string; value: number; order: number }[]>([]);
  const pipelineType = "OPPORTUNITY";
  useEffect(() => {
    getTypePipeline(pipelineType)
      .then(response => {
        console.log("Pipeline Response:", response.data.data);
        const stageOptions = response.data.data.map((stage: { name: string; id: number, order: number }) => ({
          label: stage.name,
          value: stage.id,
          order: stage.order
        }));
        setStages(stageOptions);
      })
      .catch(error => console.error("Error fetching stages:", error));
  }, [pipelineType]);
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  useEffect(() => {
    fetchTags();
  }, []);
  const userId = Number(localStorage.getItem("userId"));
  const [formUpdateData, setFormUpdateData] = useState<EditOpportunityForm>({
    id: 0,
    memberId: userId ?? 0,
    name: "",
    accountId: 0,
    stageId: 0,
    status: "",
    amount: 0,
    dueDate: new Date().toISOString(),
    expectedCloseDate: new Date().toISOString(),
    followUpDate: new Date().toISOString(),
    owner: "",
    ownerUuid: "",
    source: "",
    priority: "",
    description: "",
    probability: 0,
    tags: [] as { tagId: number; name: string }[]
  });
  const [errorsEditForm, setErrorsEditForm] = useState<Record<string, string>>({});
  const [editedUuid, setEditedUuid] = useState(null);
  const [editingDeal, setEditingDeal] = useState<EditOpportunityForm | null>(null);
  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setEditingDeal(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        tags: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : [],
        id: prev.id ?? 0,
        memberId: prev.memberId ?? 0,
      };
    });
  };
  const validateEditForm = () => {
    let newErrors: Record<string, string> = {};

    if (!editingDeal?.name || editingDeal?.name.trim() === "") {
      newErrors.name = "Opportunity Name is required.";
    } else if (editingDeal?.name?.length > 100) {
      newErrors.name = "Opportunity Name must be less than 100 characters.";
    }
    const probability = editingDeal?.probability ?? 0;
    if (!editingDeal?.accountId) newErrors.accountId = "Company is required.";
    if (!editingDeal?.stageId) newErrors.stageId = "Stage is required.";
    if (probability < 0 || probability > 100) {
      newErrors.probability = "Probability must be between 0 and 100.";
    }

    if (!editingDeal?.status) newErrors.status = "Status is required.";
    const today = new Date();
    const dueDate = editingDeal?.dueDate ? new Date(editingDeal?.dueDate) : null;
    const expectedCloseDate = editingDeal?.expectedCloseDate ? new Date(editingDeal?.expectedCloseDate) : null;
    const followUpDate = editingDeal?.followUpDate ? new Date(editingDeal?.followUpDate) : null;

    if (!dueDate || !expectedCloseDate || !followUpDate) {
      newErrors.date = "All dates (Follow Up, Expected Close, Due Date) are required.";
    } else if (
      followUpDate < today ||
      expectedCloseDate < followUpDate ||
      dueDate < expectedCloseDate
    ) {
      newErrors.date = "Invalid date order: Due Date ≥ Expected Close ≥ Follow Up ≥ Today.";
    }

    if (!editingDeal?.source) newErrors.source = "Source is required.";
    if (!editingDeal?.priority) newErrors.priority = "Priority is required.";
    if ((editingDeal?.description?.length ?? 0) > 256) {
      newErrors.description = "Description must be less than 256 characters.";
    }

    setErrorsEditForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const [companies, setCompanies] = useState<{ label: string; value: number }[]>([]);
  useEffect(() => {
    getAllCompanies()
      .then(response => {
        const companyOptions = response.data.data.map((company: { accountName: string; accountId: number }) => ({
          label: company.accountName,
          value: company.accountId,
        }));
        setCompanies(companyOptions);
      })
      .catch(error => console.error("Error fetching companies:", error));
  }, []);
  const handleEditClick = async (opportunityUuid: string) => {
    console.log("Lead UUID:", opportunityUuid);
    try {
      const response = await getOpportunityDetail(opportunityUuid);
      console.log("APi response:", response.data.data);
      console.log("All Tags:", allTags);
      console.log("Selected Tags from API:", formUpdateData.tags);
      if (response.status === 200) {
        const data = response.data.data.opportunityDetail;
        setEditingDeal(prev => ({
          ...prev,
          id: data.id,
          memberId: data.id,
          name: data.name,
          accountId: data.accountId,
          stageId: data.stageId,
          status: data.status,
          priority: data.priority,
          amount: data.amount,
          owner: data.owner,
          ownerUuid: data.ownerUuid,
          dueDate: data.dueDate,
          expectedCloseDate: data.expectedCloseDate,
          followUpDate: data.followUpDate,
          description: data.description,
          source: data.source,
          probability: data.probability ?? 0,
          tags: data.tags.map((tag: Tag) => ({
            tagId: tag.tagId,
            name: tag.name
          }))
        }));
        setEditedUuid(response.data.data.opportunityDetail.uuid);
        setFormUpdateData(prev => ({
          ...prev,
          id: data.id,
          name: data.opportunityName,
          accountId: data.accountId,
          stageId: data.stageId,
          status: data.status,
          priority: data.priority,
          amount: data.amount,
          owner: data.ownerUuid,
          dueDate: data.dueDate,
          expectedCloseDate: data.expectedCloseDate,
          followUpDate: data.followUpDate,
          description: data.description,
          source: data.source,
          tags: data.tags.map((tag: Tag) => ({
            tagId: tag.tagId,
            name: tag.name
          }))
        }));
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const handleUpdate = async () => {
    if (!editingDeal?.id) {
      console.error("Error: No valid ID found for update!", editingDeal);
      return;
    }
    if (!validateEditForm()) {
      console.error("Validation failed:", errorsEditForm);
      return;
    }
    try {
      const updatedOppor: EditOpportunityForm = {
        id: editingDeal.id,
        memberId: editingDeal.memberId,
        name: editingDeal.name,
        accountId: editingDeal.accountId,
        stageId: editingDeal.stageId,
        status: editingDeal.status,
        amount: editingDeal.amount,
        dueDate: editingDeal.dueDate,
        expectedCloseDate: editingDeal.expectedCloseDate,
        followUpDate: editingDeal.followUpDate,
        owner: editingDeal.ownerUuid,
        ownerUuid: editingDeal.ownerUuid,
        source: editingDeal.source,
        priority: editingDeal.priority,
        description: editingDeal.description,
        probability: editingDeal.probability,
        tags: editingDeal.tags
      };
      const response = await updateOpportunity(editingDeal.id, updatedOppor);
      if (response.status === 200) {
        console.log("Lead updated successfully");
        fetchDealDetail();
        setOpenEditSuccessModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const [dealToDelete, setDealToDelete] = useState<{ id: number; name: string } | null>(null);
  const handleDeleteClick = (id: number, name: string) => {
    setDealToDelete({ id, name });
  };
  const handleConfirmDelete = async () => {
    if (!dealToDelete) return;
    try {
      const response = await deleteOpportunity(dealToDelete.id);
      if (response.status === 200) {
        setResponse({ message: "Deal deleted successfully.", status: "success" });
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code !== 500) {
        setResponse({ message: error.response.data.message || "Deletion failed. Please try again.", status: "error" });
        setShowMessageModal(true);
      }
    }
  };



  const [selectedStatus, setSelectedStatus] = useState<number | "">("");
  useEffect(() => {
    setSelectedStatus(dealDetail?.stageId || "");
  }, [dealDetail]);

  const handleStageClick = async (stageId: number) => {
    console.log("Slected:", selectedStatus);
    console.log("Curent:", stageId);
    if (selectedStatus === stageId) return;

    const selectedStage = stages.find(stage => stage.value === stageId);

    if (!selectedStage) return;
    const selectedStageId = {
      stageId: selectedStage.value
    };
    const result = await Swal.fire({
      title: 'Change status?',
      text: "Do you want to change the opportunity status?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    });

    if (!result.isConfirmed) return;
    if (!result.isConfirmed) return;
    if (!dealDetail?.id) return;
    try {
      const response = await updateStatus(dealDetail.id, selectedStageId);

      if (response?.status === 200) {
        setResponse({
          status: "success",
          message: "Opportunity status updated successfully!"
        });
        setDealDetail((prev) => {
          if (!prev) return null;

          return {
            ...prev,
            stageId: stageId,
          };
        });
        fetchDealDetail();
      } else {
        setResponse({
          status: "error",
          message: "Opportunity status updated failed!"
        });
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  useEffect(() => {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "auto";
  }, []);
  const handleDeleteClickProductFromOpportunity = async (productId: number) => {
    setSelectedDeleteProductId(productId);
    setShowDeleteProductFromOpportunityModal(true);
  };
  const handleDeleteProductFromOpportunity = async () => {
    try {
      const response = await deleteProductFromOpportunity(selectedDeleteProductId);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Delete product from opportunity successfully!" });
        fetchDealDetail();
      }
    } catch (error) {
      setResponse({ status: "error", message: "Delete product from opportunity failed!" });
    } finally {
      setShowDeleteProductFromOpportunityModal(false);
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleRemoveProduct = (index: number) => {
    const updatedProducts = selectedProductDetails.filter((_, i) => i !== index);
    setSelectedProductDetails(updatedProducts);
  };
  const fetchSalePrice = async (productPriceBookId: number) => {
    try {
      const response = await getProductPriceBookDetail(productPriceBookId);
      return response.data.data.price;
    } catch (error) {
      console.error("Error fetching sale price:", error);
      return 0;
    }
  };
  const handleConfirmProducts = async () => {
    if (!selectedProducts || selectedProducts.length === 0) {
      setResponse({ status: "error", message: "Please select at least one product." });
      setShowMessageModal(true);
      return;
    }
    const productDetails: SelectedProductDetail[] = await Promise.all(
      selectedProducts.map(async (product: any) => {
        const salePrice = await fetchSalePrice(product.value);
        return {
          productPriceBookId: product.value,
          productName: product.label,
          quantity: product.quantity,
          salePrice: salePrice,
          description: product.description,
        };
      })
    );
    setSelectedProductDetails(productDetails);
    setShowProductDetailModal(true);
  };
  const confirmAddProductToOppotunity = async () => {
    if (selectedProductDetails.length === 0) {
      setResponse({ status: "error", message: "No products to add." });
      setShowMessageModal(true);
      return;
    }
    try {
      const response = await addProductToOppotunity(dealDetail?.id, selectedProductDetails);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Add product successfully!" });
        fetchDealDetail();
        setShowProductDetailModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Select failed" });
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    }
  };

  const fetchProductByPriceBook = async (priceBookId: number) => {
    setSelectedProducts([]);
    if (!priceBookId) {
      setProductOptions([]);
      return;
    }
    try {
      const response = await getAllProductsBasedOnPriceBook(priceBookId);
      const products = response.data.data;

      setProductOptions(products.map((product: Product) => ({
        value: product.id,
        label: product.productName,
      })));
    } catch (error) {
      console.error("Error fetching products:", error);
      setProductOptions([]);
    }
  };
  useEffect(() => {
    if (dealDetail?.priceBookId) {
      fetchProductByPriceBook(dealDetail.priceBookId);
    }
  }, [dealDetail?.priceBookId]);

  const handleChangeProducts = (selectedOptions: any) => {
    setSelectedProducts(selectedOptions || []);
  };
  const handleChangePriceBook = (selectedOptions: any) => {
    setSelectedPriceBook(selectedOptions || []);
  };
  const handleAddProductClick = () => {
    if (!dealDetail?.priceBookId) {
      setShowWarningModal(true);
    } else {
      setShowAddProductModal(true);
    }
  };
  const handleConfirmChoosePriceBook = async () => {
    if (!dealDetail?.id || !selectedPriceBook?.value) {
      setResponse({ status: "error", message: "Invalid deal or price book selection!" });
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
      return;
    }
    try {
      let response;
      if (dealDetail.priceBookId) {
        response = await updatePriceBookFromopportunity(dealDetail.id, selectedPriceBook.value);
      } else {
        response = await addPriceBook(dealDetail.id, selectedPriceBook.value);
      }
      if (response.status === 200) {
        setResponse({ status: "success", message: dealDetail.priceBookId ? "Updated price book successfully!" : "Added price book successfully!" });
        setShowMessageModal(true);
        fetchProductByPriceBook(selectedPriceBook.value);
        fetchDealDetail();
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Select failed" });
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    }
  };
  const fetchPriceBook = async () => {
    try {
      const response = await getAllPricebooks();
      console.log("API Response:", response.data);
      if (response.data.data != null) {
        setListPriceBooks(response.data.data);
      } else {
        setListPriceBooks([]);
      }
    } catch (error) {
      setListPriceBooks([]);
    }
  }
  useEffect(() => {
    fetchPriceBook();
  }, []);
  const priceBookOptions = listPriceBooks.map((pb) => ({
    value: pb.id,
    label: pb.name,
  }));

  const handleDeleteClickContactRole = async (contactRoleId: number) => {
    setSelectedDeleteContactRoleId(contactRoleId);
    setOpenModal(true);
  };
  const handleDeleteClickContactRoleConfirm = async () => {
    try {
      const response = await deleteContactRole(selectedDeleteContactRoleId);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Delete contact role successfully!" });
        setOpenModal(false);
        setSelectedDeleteContactRoleId(null);
        fetchDealDetail();
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    }
  }
  const handleEditClickContactRole = async (contactRoleId: number) => {
    try {
      const response = await getSingleContactRoleData(contactRoleId);
      const contactRole = response.data.data;
      setSelectedContactRole(contactRole);
      setSelectedRole(contactRole.role);
    } catch (error) {
      console.error("Error fetching contact role", error);
    }
  };


  const handleSyncPrice = async () => {
    if (!dealDetail?.id) {
      return;
    }
    try {
      const response = await syncOpportunityProductPrice(dealDetail?.id);
      if (response.status === 200) {
        fetchDealDetail();
        setResponse({ status: "success", message: "Prices synced successfully!" });
      }
    } catch (error) {
      setResponse({ status: "error", message: "Failed to sync prices!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const handleEditOpportunityProduct = async (opportunityProductId: number) => {
    if (!opportunityProductId) return;
    setSelectedOpportunityProductId(opportunityProductId);
    try {
      const response = await getOpportunityProductDetail(opportunityProductId);
      if (response.status === 200) {
        setOpportunityProductDetail(response.data.data);
      } else {
        setOpportunityProductDetail(null);
        console.error("Error fetching opportunity product ", response.status);
      }
    } catch (error) {
      setOpportunityProductDetail(null);
      console.error("Error", error);
    }
  };
  const [updateOpportunityProductDetailData, setUpdateOpportunityProductDetailData] = useState({
    quantity: 0,
    salePrice: 0,
    description: "",
  });
  useEffect(() => {
    if (opportunityProductDetail) {
      setUpdateOpportunityProductDetailData({
        quantity: opportunityProductDetail.quantity,
        salePrice: opportunityProductDetail.salePrice,
        description: opportunityProductDetail.description || "",
      });
    }
  }, [opportunityProductDetail]);

  const getEditOpportunityProductDetailData = (): UpdateOpportunityProductDTO => {
    return {
      quantity: updateOpportunityProductDetailData.quantity,
      salePrice: updateOpportunityProductDetailData.salePrice,
      description: updateOpportunityProductDetailData.description
    };
  };
  const confirmHandleUpdateOpportunityProduct = async () => {
    if (!selectedOpportunityProductId) {
      return;
    }
    try {
      const updateData = getEditOpportunityProductDetailData();
      const response = await updateOpportunityProductDetail(selectedOpportunityProductId, updateData);
      if (response.status === 200) {
        fetchDealDetail();
        setResponse({ status: "success", message: "Update Opportunity Product Successfully!" });
        setSelectedOpportunityProductId(null);
      }
    } catch (error) {
      setResponse({ status: "error", message: "Update Opportunity Product Failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  }

  const handleSelectEditContactRole = (contactIds: number | number[]) => {
    setSelectedContactRoles((prev) => {
      if (Array.isArray(contactIds)) {
        return contactIds;
      } else {
        return prev.includes(contactIds)
          ? prev.filter((id) => id !== contactIds)
          : [...prev, contactIds];
      }
    });
  };
  const handleSelectChange = (selectedOption: any, field: string) => {
    const value = selectedOption?.value || "";
    setEditLogCall((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: value,
      };
    });
    setEditingDeal((prevState) => {
      const newState = {
        ...prevState!,
        [field]: value,
      };
      if (field === "stageId" && stages.find(t => t.value == value)) {
        const order = stages.find(o => o.value == value)?.order ?? 0;
        const probability = (order / stages.length) * 100;
        newState.probability = parseFloat(probability.toFixed(3));
      }

      return newState;
    });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setNewTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (dealDetail?.contactRoles) {
      const existingContactIds = dealDetail.contactRoles.map((contact) => contact.contactId);
      setSelectedContactRoles(existingContactIds);
    }
    if (dealDetail?.priceBookId) {
      const selectedOption = priceBookOptions.find((option) => option.value === dealDetail.priceBookId) || null;
      setSelectedPriceBook(selectedOption);
    }
  }, [dealDetail]);
  const handleChangeContactRole = (selectedOptions: MultiValue<{ value: string; label: string }>) => {
    const selectedIds = selectedOptions ? selectedOptions.map((opt) => Number(opt.value)) : [];
    setSelectedContactRoles(selectedIds);
  };
  const handleConfirmAddContactRoles = async () => {
    try {
      const updateData = selectedContactRoles.map(contactId => ({
        contactId,
        role: null,
      }));
      const response = await addContactRole(dealDetail?.id, updateData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Contact role added successfully!" });
        fetchDealDetail();
        setSelectedRole("");
        setShowMessageModal(true);
      }

    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const handleUpdateContactRole = async () => {
    if (!selectedContactRole) return;
    try {
      const updateData = {
        contactId: selectedContactRole.contactId,
        role: selectedRole,
      };
      const response = await updateSingleContactRole(selectedContactRole.id, updateData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Contact role updated successfully!" });
        fetchDealDetail();
        setSelectedRole("");
        setShowMessageModal(true);
      }

    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const [listContactRoles, setListContactRoles] = useState<Contact[]>([]);
  const fetchContactRoles = async (accountId: number): Promise<void> => {
    try {
      const response = await getAllContacts(accountId);
      console.log("API Response:", response.data.data);
      setListContactRoles(response.data.data);
    } catch (error) {
      console.error("Error fetching contact roles:", error);
    }
  };
  useEffect(() => {
    if (dealDetail?.accountId) {
      fetchContactRoles(dealDetail.accountId);
    }
  }, [dealDetail?.accountId]);
  const contactOptions = listContactRoles.map((contact) => ({
    value: contact.contactId.toString(),
    label: contact.contactName,
  }));
  const fetchDealDetail = async () => {
    if (!uuid) return;
    try {
      const response = await getOpportunityDetail(uuid);
      console.log("Updated Deal Detail API Response:", response.data.data);
      setDealDetail({
        ...response.data.data.opportunityDetail,
        contactRoles: response.data.data.contactRoles || [],
        opportunityProductResponses: response.data.data.opportunityProductResponses || []
      });
    } catch (error: any) {
      if (error.response?.data?.code === 1028) {
        navigate("/error-404");
      }
    }
  };
  useEffect(() => {
    fetchDealDetail();
  }, [uuid]);
  const fetchLogCalls = async () => {
    if (!dealDetail?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberLogCall("OPPORTUNITY", dealDetail?.id);
      setLogCalls(response.data.data || []);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };
  const [editLogCall, setEditLogCall] = useState<LogCallDataUpdate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
  });
  const handleDeleteClickLogCall = (id: number) => {
    setLogCallToDelete({ id });
    setShowDeleteLogCallModal(true);
  };
  const fetchListLeadAssignType = async () => {
    try {
      const response = await listLeadsOption();
      setListLeadAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching leads: ", err);
      setError("Failed to load leads.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListLeadAssignType();
  }, []);
  const fetchListContactAssignType = async () => {
    try {
      const response = await listContactsOptionn();
      setListContactAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching contacts: ", err);
      setError("Failed to load contacts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListContactAssignType();
  }, []);
  const fetchAccountRelatedToType = async () => {
    try {
      const response = await listAccountsOption();
      setListAccountRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts: ", err);
      setError("Failed to load accounts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountRelatedToType();
  }, []);
  const fetchUserCallList = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUserCall(response.data.data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserCallList();
  }, []);
  const handleUpdateTaskSelectChange = (name: string, value: string | number) => {
    setEditLogCall((prevData) => {
      if (!prevData) return prevData;

      if (name === "assignRecord") {
        return {
          ...prevData,
          assignRecord: value as number,
        };
      }

      if (name === "targetRecord") {
        return {
          ...prevData,
          targetRecord: value as number,
        };
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "assignId") {
        return {
          ...prevData,
          assignee: {
            ...prevData.assignee,
            id: value as number,
          },
        };
      }

      if (name === "targetId") {
        return {
          ...prevData,
          targets: {
            ...prevData.targets,
            id: value as number,
          },
        };
      }
      return {
        ...prevData,
        [name]: value,
      };
    });

  };


  const handleUpdateTaskInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditEventData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "responsible") {
        const selectedUser = listUserCall.find(user => user.uuid === value);
        return {
          ...prevData,
          responsible: selectedUser ? { uuid: selectedUser.uuid, username: selectedUser.username } : prevData.responsible
        };
      }
      return {
        ...prevData,
        [name]: name === "memberId" || name === "assignId" || name === "targetId" ? Number(value) || 0 : value,
      };
    });
  };
  const fetchListOpportunitiesRelatedToType = async () => {
    try {
      const response = await listOpportunitiesOption();
      console.log(response.data.data, "abcxyz data")
      setListOpportunitiesRelatedToType(response.data.data || []);
      console.log(listOpportunitiesRelatedToType, "bcd data")
    } catch (err) {
      console.error("Error fetching opportunities: ", err);
      setError("Failed to load opportunities.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListOpportunitiesRelatedToType();
  }, []);
  const fetchSelectedLogCall = async (id: number) => {
    try {
      setSelectedLogCallId({ id });
      const response = await detailLogCall(id);
      const logCallData = response.data.data;
      setEditLogCall({
        userCall: logCallData.userCall?.uuid || "",
        status: logCallData.status || "",
        followUpDate: logCallData.followUpTime || "",
        note: logCallData.notes || "",
        assignType: logCallData.assignType || "",
        assignRecord: logCallData.assignee?.id || 0,
        targetType: logCallData.targetType || "",
        targetRecord: logCallData.targets?.id || 0,
      });
      if (editLogCall.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (editLogCall.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }
      if (editLogCall.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (editLogCall.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
      setShowEditLogCallModal(true);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditClickLogCall = (id: number) => {
    console.log(id, "asdad");
    setSelectedLogCallId({ id });
    fetchSelectedLogCall(id);
  }
  const handleUpdateLogCallStatus = async (id: number, status: string) => {
    console.log(status, "abc");
    try {
      const response = await updateLogCallStatus(id, status);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call status updated successfully!" });
        fetchLogCalls();
      }
    } catch (error) {
      setResponse({ status: "success", message: "Log call status updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const [newLogCall, setNewLogCall] = useState<LogCallDataCreate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "OPPORTUNITY",
    targetRecord: dealDetail?.id ?? 0,
    checkedCreateFollowingTask: false,
  });
  useEffect(() => {
    if (relateTaskOptions.length > 0 && newLogCall.targetType !== "") {
      setNewLogCall((prev) => ({
        ...prev,
        targetRecord: Number(dealDetail?.id)
      }));
    }
  }, [relateTaskOptions, newLogCall.targetType]);
  const getNewLogCallData = (): LogCallDataCreate => {
    return {
      userCall: newLogCall.userCall,
      status: newLogCall.status,
      followUpDate: newLogCall.followUpDate
        ? new Date(
          new Date(newLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: newLogCall.note,
      assignType: newLogCall.assignType,
      assignRecord: newLogCall.assignRecord,
      targetType: newLogCall.targetType,
      targetRecord: newLogCall.targetRecord,
      checkedCreateFollowingTask: newLogCall.checkedCreateFollowingTask,
    };
  };

  const resetAddLogCallForm = () => {
    setNewLogCall({
      userCall: "",
      status: "",
      followUpDate: "",
      note: "",
      assignType: "",
      assignRecord: 0,
      targetType: "",
      targetRecord: 0,
      checkedCreateFollowingTask: false,
    });
  };
  const handleCreateLogCall = async () => {
    try {
      const logCallData = getNewLogCallData();
      const response = await createLogCall(logCallData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call created successfully!" });
        fetchLogCalls();
        resetAddLogCallForm();
      }
    } catch (err) {
      console.error("Error creating log call:", err);
      setResponse({ status: "error", message: "Log call created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateLogCall = async (logCallId: number) => {
    if (!editLogCall) return;
    const updatedLogCall: LogCallDataUpdate = {
      userCall: editLogCall.userCall || "",
      status: editLogCall.status ?? "",
      followUpDate: editLogCall.followUpDate
        ? new Date(
          new Date(editLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: editLogCall.note ?? "",
      assignType: editLogCall.assignType,
      assignRecord: editLogCall.assignRecord,
      targetType: editLogCall.targetType,
      targetRecord: editLogCall.targetRecord,
    };

    try {
      const response = await updateLogCall(logCallId, updatedLogCall);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call updated successfully!" });
        fetchLogCalls();
      }
    } catch (err) {
      console.error("Error updating log call:", err);
      setResponse({ status: "error", message: "Log call updated failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleConfirmDeleteLogCall = async () => {
    if (!logCallToDelete) return;
    console.log(logCallToDelete)
    try {
      const response = await deleteLogCall(logCallToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setLogCalls((prevLogCalls) =>
          prevLogCalls.filter((logCall) => logCall.id !== logCallToDelete.id)
        );
        setResponse({ status: "success", message: "Log call deleted successfully!" });
      }
      setShowDeleteLogCallModal(false);
    } catch (err) {
      setResponse({ status: "error", message: "Log call deleted failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };


  const route = all_routes
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [isEditor2, setIsEditor2] = useState(false);
  const [isEditor3, setIsEditor3] = useState(false);
  const options = [
    { value: 'marketing', label: 'Marketing Pipeline' },
    { value: 'sales', label: 'Sales Pipeline' }
  ];
  const rolesOfContactRole = [
    { value: "BUSINESS_USER", label: "Business User" },
    { value: "DECISION_MAKER", label: "Decision Maker" },
    { value: "ECONOMIC_BUYER", label: "Economic Buyer" },
    { value: "ECONOMIC_DECISION_MAKER", label: "Economic Decision Maker" },
    { value: "EVALUATOR", label: "Evaluator" },
    { value: "EXECUTIVE_SPONSOR", label: "Executive Sponsor" },
    { value: "INFLUENCER", label: "Influencer" },
    { value: "TECHNICAL_BUYER", label: "Technical Buyer" },
    { value: "OTHER", label: "Other" },
  ];
  const sortbydata = [
    { value: 'Sort By Date', label: 'Sort By Date' },
    { value: 'Ascending', label: 'Ascending' },
    { value: 'Descending', label: 'Descending' }
  ];
  const [showFirstField, setShowFirstField] = useState(false);

  const handleSaveAndNext = () => {
    setShowFirstField(true);
  };
  const handleCancel = () => {
    setShowFirstField(false);
  };
  const [showFirstField2, setShowFirstField2] = useState(false);

  const handleSaveAndNext2 = () => {
    setShowFirstField2(true);
  };
  const handleCancel2 = () => {
    setShowFirstField2(false);
  };
  const [showFirstField3, setShowFirstField3] = useState(false);

  const handleSaveAndNext3 = () => {
    setShowFirstField3(true);
  };
  const handleCancel3 = () => {
    setShowFirstField3(false);
  };
  const tooltipContent = (
    <Tooltip id="tooltip">
      There are no email accounts configured. Please configure your email account in order to Send/Create Emails.
    </Tooltip>
  );

  const [quote, setQuote] = useState<Quote>({
    opportunityId: 0,
    expiryDate: "",
    name: "",
    notes: "",
    discountRate: 0,
    taxRate: 0,
  });

  const handleAddNewClick = () => {
    setQuote({
      opportunityId: 0,
      expiryDate: "",
      name: "",
      notes: "",
      discountRate: 0,
      taxRate: 0,
    });
    setErrors({});
  };
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validateQuote = () => {
    const newErrors: Record<string, string> = {};
    let exDate: string | null = null;
    if (quote.expiryDate) {
      const parsedDate = new Date(quote.expiryDate);
      if (!isNaN(parsedDate.getTime())) {
        exDate = parsedDate.toISOString();
      } else {
        newErrors.date = "Invalid expiration date.";
        return;
      }
    } else {
      if (!quote.expiryDate.trim()) {
        newErrors.date = "Expiration Date is required";
      }
    }
    if (!quote.name.trim()) newErrors.quoteName = "Quote Name is required";
    if (quote.notes && quote.notes.length > 256) {
      newErrors.description = "Description must not exceed 256 characters.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    let cleanedValue = value.replace(/^0+(?=\d)/, '');
    if (cleanedValue === "" || isNaN(Number(cleanedValue))) {
      cleanedValue = "0";
    }
    let numericValue = parseInt(cleanedValue, 10);
    numericValue = Math.max(0, Math.min(100, numericValue));
    setQuote(prev => ({ ...prev, [name]: numericValue }));
  };

  const handleChange = (event: any) => {
    let { name, value } = event.target;
    if (!name && event.target?.getAttribute) {
      name = event.target.getAttribute("name");
      value = event.target.innerHTML;
    }
    setQuote((prevQuote) => ({
      ...prevQuote,
      [name]: value,
    }));
    setEditingDeal(prevState => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value,
        memberId: prevState.memberId ?? 0
      };
    });
  };

  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const handleSubmit = async () => {
    try {
      if (!validateQuote()) {
        console.error("Validation failed:", errors);
        return;
      }
      let exDate: string | null = null;
      if (quote.expiryDate) {
        const parsedDate = new Date(quote.expiryDate);
        if (!isNaN(parsedDate.getTime())) {
          exDate = parsedDate.toISOString();
        }
      }
      const params = {
        opportunityId: dealDetail ? dealDetail.id : null,
        taxRate: quote.taxRate,
        discountRate: quote.discountRate,
        name: quote.name,
        notes: quote.notes,
        expiryDate: exDate,
      };

      const response = await addQuote(params);
      console.log("Quote added successfully:", response.data);
      setShowQuoteModal(false);
      await fetchQuotes();
      setResponse({ status: "success", message: "Add quote successfully!" });
    } catch (error) {
      console.error("Error adding quote:", error);
      setResponse({ status: "error", message: "Add quote failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };



  const subtotal = dealDetail?.opportunityProductResponses?.reduce(
    (sum, product) => sum + product.salePrice * product.quantity,
    0
  ) ?? 0;

  const discountAmount = subtotal * (quote.discountRate / 100);
  const taxAmount = (subtotal - discountAmount) * (quote.taxRate / 100);

  const totalDealPrice = subtotal - discountAmount + taxAmount;


  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchQuotes = async () => {
    try {
      const response = await getQuote(dealDetail?.id);
      setQuotes(response.data.data);
    } catch (error) {
      console.error("Error fetching quotes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dealDetail?.id) {
      fetchQuotes();
    }
  }, [dealDetail?.id]);
  const fetchTasks = async () => {
    if (!dealDetail?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberTasks("OPPORTUNITY", dealDetail?.id);
      setTasks(response.data.data || []);
    } catch (err) {
      console.error("Error fetching tasks", err);
      setError("Failed to load tasks.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (dealDetail?.id) {
      fetchLogCalls();
      fetchEvents();
      fetchTasks();
    }
  }, [dealDetail?.id]);
  const handleEditClickTask = (id: number) => {
    console.log(id, "asdad");
    setSelectedTaskId({ id });
    fetchSelectedTask(id);
  }
  const fetchSelectedTask = async (id: number) => {
    try {
      setSelectedTaskId({ id: id });
      const response = await detailTask(id);
      console.log(response.data.data, "hihihhehehe");
      setEditingTask(response.data.data);

    } catch (err) {
      console.error("Error fetching task.", err);
      setError("Failed to load task.");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteClickTask = (id: number) => {
    setTaskToDelete({ id });
  };
  const handleConfirmDeleteTask = async () => {
    if (!taskToDelete) return;
    console.log(taskToDelete)
    try {
      const response = await deleteTask(taskToDelete.id);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task deleted successfully!" });
        setTasks((prevTask) =>
          prevTask.filter((taskToDelete) => taskToDelete.id !== taskToDelete.id)
        );
        fetchTasks();
      }
    } catch (err) {
      console.error("Error deleting task", err);
      setResponse({ status: "error", message: "Task deleted failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const [newTaskData, setNewTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });

  const [editTaskData, setEditTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });
  const getNewTaskData = (): CreateTaskDTO => {
    return {
      memberId: dealDetail?.id ?? 0,
      title: newTaskData.title,
      category: newTaskData.category,
      responsible: newTaskData.responsible,
      startDate: newTaskData.startDate
        ? new Date(
          new Date(newTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: newTaskData.endDate
        ? new Date(
          new Date(newTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: newTaskData.status,
      priority: newTaskData.priority,
      description: newTaskData.description,
      assignType: newTaskData.assignType,
      assignId: newTaskData.assignId,
      targetType: newTaskData.targetType,
      targetId: newTaskData.targetId,
    };
  };
  const getEditTaskData = (): UpdateTaskDTO => {
    return {
      memberId: dealDetail?.id ?? 0,
      title: editTaskData.title,
      category: editTaskData.category,
      responsible: editTaskData.responsible,

      startDate: editTaskData.startDate
        ? new Date(
          new Date(editTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: editTaskData.endDate
        ? new Date(
          new Date(editTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: editTaskData.status,
      priority: editTaskData.priority,
      description: editTaskData.description,
      assignType: editTaskData.assignType,
      assignId: editTaskData.assignId,
      targetType: editTaskData.targetType,
      targetId: editTaskData.targetId,
    };
  };

  const handleCreateTasks = async () => {
    try {
      const newTask = getNewTaskData();
      const response = await createTask(newTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task created successfully!" });
        resetNewTaskForm();
        fetchTasks();
      }
    } catch (err) {
      console.error("Error creating task:", err);
      setResponse({ status: "error", message: "Task created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const handleUpdateTask = async (taskId: number) => {
    try {
      const updatedTask = getEditTaskData();
      const response = await updateTask(taskId, updatedTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task updated successfully!" });
        fetchTasks();
        resetEditTaskForm();
      }
    } catch (err) {
      console.error("Error updating task:", err);
      setResponse({ status: "error", message: "Task updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewTaskForm = () => {
    setNewTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };

  const resetEditTaskForm = () => {
    setEditTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };
  useEffect(() => {
    if (dealDetail) {
      console.log("abjkasckljacasjfasf", dealDetail.id)
      setNewTaskData(prev => ({
        ...prev,
        targetType: "OPPORTUNITY",
        targetId: dealDetail.id ?? 0,
      }));
      setNewEventData(prev => ({
        ...prev,
        targetType: "OPPORTUNITY",
        targetIds: dealDetail.id ?? 0,
      }));
      setNewLogCall(prev => ({
        ...prev,
        targetType: "OPPORTUNITY",
        targetRecord: dealDetail.id ?? 0,
      }));
    }
  }, [dealDetail]);
  const handleTaskRelatedToTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({ value: t.accountId, label: t.accountName }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({ value: t.id, label: t.name }));
    }
    setRelateTaskOptions(newOptions);
    setNewTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setNewLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetIds: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetIds: newOptions[0].value })
    }));
  };
  const handleTaskAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;
    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }));
    }
    setAssignTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assigneeId: [newOptions[0].value] })
    }));
    setEditEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assigneeId: [newOptions[0].value] })
    }));
  };
  const source = [
    { value: "ADVERTISEMENT", label: "Advertisement" },
    { value: "CUSTOMER_EVENT", label: "Customer Event" },
    { value: "EMPLOYEE_REFERRAL", label: "Employee Referral" },
    { value: "EXTERNAL_REFERRAL", label: "External Referral" },
    { value: "GOOGLE_ADWORDS", label: "Google Adwords" },
    { value: "PARTNER", label: "Partner" },
    { value: "PURCHASED_LIST", label: "Purchased List" },
    { value: "TRADE_SHOW", label: "Trade Show" },
    { value: "WEBINAR", label: "Webinar" },
    { value: "WEBSITE", label: "Website" },
    { value: "OTHER", label: "Other" }
  ];
  const dispatch = useDispatch();
  const activityToggle = useSelector((state: any) => state?.activityTogglePopup);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">Opportunity Overview</h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* Deals User */}
              <div className="contact-head">
                <div className="row align-items-center">
                  <div className="col-sm-8">
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link to={route.deals}>
                          <i className="ti ti-arrow-narrow-left" />
                          Opportunity
                        </Link>
                      </li>
                      <li>{dealDetail?.name || 'N/A'}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body pb-2">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-2">
                      <div>
                        <h5 className="mb-1 d-flex align-items-center">
                          <span>{dealDetail?.name || 'N/A'}</span>
                          <div className="star-icon ms-2">
                            <i className="fa-solid fa-star" />
                          </div>
                          <div className="dropdown table-action ms-auto">
                            <Link
                              to="#"
                              className="action-icon"
                              data-bs-toggle="dropdown"
                              aria-expanded="true"
                            >
                              <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{
                                position: "absolute",
                                inset: "0px auto auto 0px",
                                margin: "0px",
                                transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                              }}
                              data-popper-placement="bottom-start"
                            >
                              {/* Edit Action */}
                              <Link
                                className="dropdown-item edit-popup"
                                to="#"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvas_edit"
                                onClick={() => {
                                  if (dealDetail?.uuid) {
                                    setErrorsEditForm({});
                                    handleEditClick(dealDetail?.uuid);
                                  }
                                }}
                              >
                                <i className="ti ti-edit text-blue"></i> Edit
                              </Link>

                              {/* Delete Action */}
                              {/* <Link
                                className="dropdown-item"
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_deal"
                                onClick={() => dealDetail?.id && handleDeleteClick(dealDetail?.id, dealDetail?.name)}
                              >
                                <i className="ti ti-trash text-danger"></i> Delete
                              </Link> */}
                            </div>
                          </div>
                        </h5>
                        <p className="mb-1">
                          <i className="ti ti-building" /> {dealDetail?.accountName || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Deals User */}
            </div>
            {/* Deals Sidebar */}
            <div className="col-xl-3 theiaStickySidebar">
              <div className="card">
                <div className="card-body p-3">
                  <h6 className="mb-3 fw-semibold">Opportunity Information</h6>
                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Stage</span>
                      <span className="col-6">{dealDetail?.stageName || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Value</span>
                      <span className="col-6">{dealDetail?.amount || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Probability</span>
                      <span className="col-6">{dealDetail?.probability || "N/A"} %</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Due Date</span>
                      <span className="col-6">
                        {dealDetail?.dueDate ? new Date(dealDetail.dueDate).toLocaleDateString() : "N/A"}
                      </span>
                    </li>

                    <li className="row mb-3">
                      <span className="col-6">Expected Close Date</span>
                      <span className="col-6">
                        {dealDetail?.expectedCloseDate ? new Date(dealDetail.expectedCloseDate).toLocaleDateString() : "N/A"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Follow Up Date</span>
                      <span className="col-6">
                        {dealDetail?.followUpDate ? new Date(dealDetail.followUpDate).toLocaleDateString() : "N/A"}
                      </span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Source</span>
                      <span className="col-6">{dealDetail?.source || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Priority</span>
                      <span className="col-6">{dealDetail?.priority || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Description</span>
                      <span className="col-6">{dealDetail?.description || "N/A"}</span>
                    </li>
                    <li className="row mb-3">
                      <span className="col-6">Status</span>
                      <span className="col-6">{dealDetail?.status || "N/A"}</span>
                    </li>
                  </ul>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h6 className="mb-3 fw-semibold">Owner</h6>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <p>{dealDetail?.owner || "N/A"}</p>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Tags</h6>
                  {(dealDetail?.tags ?? []).length > 0 ? (
                    dealDetail!.tags!.map((tag) => (
                      <span key={tag.tagId} className="badge bg-primary me-2">{tag.name}</span>
                    ))
                  ) : (
                    "N/A"
                  )}
                  <hr />
                  <div className="d-flex align-items-center justify-content-between w-100 flex-wrap">
                    <h6 className="mb-3 fw-semibold">Contact Roles ({dealDetail?.contactRoles.length ?? 0})</h6>
                    <div className="d-flex gap-2 flex-wrap">
                      <Link
                        to="#"
                        className="link-purple mb-3 fw-medium"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_contact"
                      >
                        <i className="ti ti-circle-plus me-1" />
                        Update Contact Role
                      </Link>
                    </div>
                  </div>

                  {dealDetail?.contactRoles && dealDetail.contactRoles.length > 0 ? (
                    dealDetail.contactRoles.map((contact) => (
                      <div
                        key={contact.contactId}
                        className="d-flex align-items-center justify-content-between p-2 border rounded mb-2"
                      >
                        <div className="d-flex flex-column">
                          <Link
                            to={`/crm/contacts-details/${contact.contactId}`}
                            className="text-primary fw-semibold text-decoration-none d-flex align-items-center"
                          >
                            <i className="ti ti-user me-2"></i> {contact.contactName}
                          </Link>
                          <small
                            className="text-muted"
                            style={{
                              maxWidth: "150px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "block",
                            }}
                          >
                            Role: {contact.role || "No role assigned"}
                          </small>
                        </div>

                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Actions
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_selected_contactroles"
                                onClick={() => handleEditClickContactRole(contact.id)}
                              >
                                <i className="ti ti-edit me-2"></i> Edit
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center text-danger"
                                onClick={() => handleDeleteClickContactRole(contact.id)}
                              >
                                <i className="ti ti-trash me-2"></i> Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No contacts available</p>
                  )}

                  <hr />
                  <div className="d-flex align-items-center justify-content-between w-100 flex-wrap">
                    <div className="mb-3">
                      <h6 className="fw-semibold mb-1">
                        Products ({dealDetail?.opportunityProductResponses?.length ?? 0})
                      </h6>
                      {dealDetail?.priceBookName && (
                        <span className="text-muted small">
                          Selected Price Book: <strong>{dealDetail.priceBookName}</strong>
                        </span>
                      )}
                    </div>
                    <div className="d-flex gap-2 flex-wrap">
                      <a
                        href="#"
                        className="link-purple mb-3 fw-medium d-inline-flex align-items-center"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddProductClick();
                        }}
                      >
                        <i className="ti ti-circle-plus me-1" />
                        Add Product
                      </a>
                      <a
                        href="#choose_pricebook"
                        className="link-purple mb-3 fw-medium d-inline-flex align-items-center"
                        data-bs-toggle="modal"
                      >
                        <i className="ti ti-circle-plus me-1" />
                        Choose Price Book
                      </a>

                      <button
                        type="button"
                        className="btn btn-outline-primary mb-3 fw-medium"
                        onClick={handleSyncPrice}
                      >
                        <i className="ti ti-refresh me-1" />
                        Sync Price
                      </button>
                    </div>
                  </div>


                  {dealDetail?.opportunityProductResponses && dealDetail.opportunityProductResponses.length > 0 ? (
                    dealDetail.opportunityProductResponses.map((product) => (
                      <div
                        key={product.id}
                        className="d-flex align-items-center justify-content-between p-2 border rounded mb-2"
                      >
                        <div className="d-flex flex-column">
                          <span className="text-primary fw-semibold">
                            <i className="ti ti-package me-2"></i>
                            <Link to={`/crm/products-details/${product.productId}`} className="text-primary">
                              {product.productName}
                            </Link>
                          </span>
                          <small className="text-muted">
                            Price: ${product.salePrice || "N/A"} - Quantity: {product.quantity || 0}
                          </small>
                        </div>

                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Actions
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_selected_product"
                                onClick={() => handleEditOpportunityProduct(product.id)}
                              >
                                <i className="ti ti-edit me-2"></i> Edit
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item d-flex align-items-center text-danger"
                                onClick={() => handleDeleteClickProductFromOpportunity(product.id)}
                              >
                                <i className="ti ti-trash me-2"></i> Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No products available</p>
                  )}

                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Created At</span>
                      <span className="col-6">
                        {dealDetail?.createdAt ? new Date(dealDetail.createdAt).toLocaleDateString() : "N/A"}
                      </span>
                    </li>
                    <li className="row mb-0">
                      <span className="col-6">Created By</span>
                      <span className="col-6">
                        {dealDetail?.createdBy || "N/A"}
                      </span>
                    </li>
                  </ul>
                  <hr />
                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">Last Modified</span>
                      <span className="col-6">
                        {dealDetail?.updatedAt ? new Date(dealDetail.updatedAt).toLocaleDateString() : "N/A"}
                      </span>
                    </li>
                    <li className="row mb-0">
                      <span className="col-6">Modified By</span>
                      <span className="col-6">
                        {dealDetail?.updatedBy || "N/A"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Deals Sidebar */}
            {/* Deals Details */}
            <div className="col-xl-9">
              <div className="card mb-3">
                <div className="card-body pb-0">
                  <h4 className="fw-semibold mb-3">Opportunity Pipeline Status</h4>
                  <div className="pipeline-list">
                    <ul>
                      {stages.length > 0 ? (
                        stages.map((stage, index) => (
                          <li key={stage.value}>
                            <Link
                              to="#"
                              className={stage.value === selectedStatus ? `bg-${getStageColor(index)}` : "bg-gray-300"}
                              onClick={() => handleStageClick(stage.value)}
                            >
                              {stage.label}
                            </Link>
                          </li>
                        ))
                      ) : (
                        <p>No stages available</p>
                      )}
                    </ul>
                  </div>
                  <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#activities"
                        className="nav-link active"
                        onClick={() => setReloadActivity(!reloadActivity)}
                      >
                        <i className="ti ti-alarm-minus me-1" />
                        Activities
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#quotes"
                        className="nav-link"
                      >
                        <i className="ti ti-notes me-1" />
                        Quotes
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#tasks"
                        className="nav-link"
                      >
                        <i className="ti ti-list-check me-1" />
                        Tasks
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#events"
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-event me-1" />
                        Events
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#calls"
                        className="nav-link"
                      >
                        <i className="ti ti-phone me-1" />
                        Calls
                      </Link>
                    </li>

                  </ul>
                </div>
              </div>
              {/* Tab Content */}
              <div className="tab-content pt-0">
                {/* Activities */}
                {dealDetail && <ActivityList id={dealDetail.id} type={ACTIVITY_TYPES.OPPORTUNITY} reload={reloadActivity} />}
                {/* /Activities */}
                {/* Quotes */}
                <div className="tab-pane fade" id="quotes">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Quotes</h4>
                      <div className="d-inline-flex align-items-center">
                        <Link to="#" className="link-purple fw-medium"
                          onClick={() => {
                            handleAddNewClick();
                            setShowQuoteModal(true);
                          }}>
                          <i className="ti ti-circle-plus me-1" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      {loading ? (
                        <p>Loading quotes...</p>
                      ) : quotes.length > 0 ? (
                        <ul className="list-group">
                          {quotes.map((quote: QuoteList) => (
                            <li key={quote.version} className="list-group-item d-flex justify-content-between align-items-center">
                              <span>Name: {quote.name} - Version: {quote.version}</span>
                              <a
                                href={quote.fileUrl ? quote.fileUrl : "#"}
                                download={quote.fileUrl ? true : false}
                                className="btn btn-outline-primary d-flex align-items-center"
                                onClick={(e) => {
                                  if (!quote.fileUrl) {
                                    e.preventDefault();
                                    setShowMessageModal(true);
                                    setResponse({ status: "error", message: "Download link is not available!" });
                                  } else {
                                    setShowMessageModal(true);
                                    setResponse({ status: "success", message: "Download started successfully!" });
                                  }
                                }}
                              >
                                <i className="ti ti-file" style={{ fontSize: "20px", marginRight: "5px" }}></i>
                                Download
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted">No quotes available</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Quotes */}
                {/* Calls */}
                <div className="tab-pane fade" id="calls">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Calls</h4>
                      <div>
                        <div className="d-flex">
                          <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_call">
                            <i className="ti ti-plus"></i> Add New Log Call
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="card-body">
                      {logCalls.length > 0 ? (
                        logCalls.map((call, index) => (
                          <div key={index} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                  <i className="ti ti-phone" />
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <div>
                                      <span className="badge bg-primary me-2">{call.userCall || 'Unknown User'}</span>
                                      <span
                                        className={`badge ${call.status === 'BUSY' ? 'bg-danger' :
                                          call.status === 'NO_ANSWER' ? 'bg-warning' :
                                            call.status === 'LEFT_VOICE_MESSAGE' ? 'bg-info' :
                                              call.status === 'MOVING_FORWARD' ? 'bg-success' :
                                                'bg-secondary'
                                          }`}
                                      >
                                        {call.status?.replace(/_/g, ' ')}
                                      </span>
                                    </div>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_call"
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleEditClickLogCall(call.id);
                                          }}
                                        >
                                          <i className="ti ti-edit text-blue me-1" />
                                          Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_logcall"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteClickLogCall(call.id)}
                                        >
                                          <i className="ti ti-trash text-danger me-1" />
                                          Delete
                                        </Link>

                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">{call.notes || 'No notes'}</p>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar me-1"></i>
                                        {call.callTime ? `Call time: ${new Date(call.callTime).toLocaleString()}` : 'No call time'}
                                      </p>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar-event me-1"></i>
                                        {call.followUpTime ? `Follow-up: ${new Date(call.followUpTime).toLocaleString()}` : 'No follow-up'}
                                      </p>
                                    </div>
                                    <div className="dropdown">
                                      <button
                                        className={`btn btn-sm ${call.status === 'BUSY' ? 'btn-danger' :
                                          call.status === 'NO_ANSWER' ? 'btn-warning' :
                                            call.status === 'LEFT_VOICE_MESSAGE' ? 'btn-info' :
                                              call.status === 'MOVING_FORWARD' ? 'btn-success' :
                                                'btn-secondary'
                                          } dropdown-toggle`}
                                        data-bs-toggle="dropdown"
                                      >
                                        {call.status?.replace(/_/g, ' ')}
                                      </button>
                                      <div className="dropdown-menu">
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'BUSY')}
                                        >
                                          Busy
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'NO_ANSWER')}
                                        >
                                          No Answer
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'UNAVAILABLE')}
                                        >
                                          Unavailable
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'WRONG_NUMBER')}
                                        >
                                          Wrong Number
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'LEFT_VOICE_MESSAGE')}
                                        >
                                          Left Voice Message
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'MOVING_FORWARD')}
                                        >
                                          Moving Forward
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-5">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-phone-call fs-24 text-primary"></i>
                          </div>
                          <h5>No calls logged yet</h5>
                          <p className="text-muted">Log your first call by clicking the button above</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Calls */}
                {/* Tasks */}
                <div className="tab-pane fade" id="tasks">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Tasks</h4>
                      <div>
                        <div className="d-flex">
                          <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_task">
                            <i className="ti ti-plus"></i> Add New Task
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Task list section */}
                      {tasks.length > 0 ? (
                        tasks.map((task, index) => (
                          <div key={index} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                  <i className="ti ti-notes" />
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-medium mb-0">{task.title}</h6>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_task"
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleEditClickTask(task.id);
                                          }}
                                        >
                                          <i className="ti ti-edit text-blue"></i> Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_task"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteClickTask(task.id)}
                                        >
                                          <i className="ti ti-trash text-danger me-1" />
                                          Delete
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">{task.description || 'No description'}</p>
                                  <div className="d-flex flex-wrap gap-2 mb-1">
                                    <span className="badge bg-info">Status: {task.status}</span>
                                    <span className="badge bg-warning">Priority: {task.priority}</span>
                                    <span className="badge bg-secondary">Category: {task.category}</span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted small">
                                      <i className="ti ti-calendar me-1"></i>
                                      Start: {new Date(task.startDate).toLocaleString()}
                                      {task.endDate ? ` | End: ${new Date(task.endDate).toLocaleString()}` : ' | No end date'}
                                    </p>
                                    <p className="mb-0 text-muted small">
                                      <i className="ti ti-user me-1"></i>
                                      {task.responsible.username || 'No responsible'}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-3">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-list-check fs-24 text-primary"></i>
                          </div>
                          <h5>No tasks found</h5>
                          <p className="text-muted">Create a new task to get started</p>
                        </div>
                      )}
                    </div>
                    {/* /Recent Task List */}
                  </div>
                </div>
                {/* /Tasks */}
                {/* Create Task */}
                <div className="modal custom-modal fade modal-padding" id="create_task" role="dialog">
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Create Task</h5>
                        <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="row">
                            <div className="col-md-12">
                              {/* Title */}
                              <div className="mb-3">
                                <label className="col-form-label">Title <span className="text-danger">*</span></label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="title"
                                  value={newTaskData.title}
                                  onChange={handleInputChange}
                                />
                              </div>

                              {/* Category */}
                              <div className="mb-3">
                                <label className="col-form-label">Category</label>
                                <Select
                                  options={selectTaskCategoryOptions}
                                  placeholder="Choose"
                                  classNamePrefix="react-select"
                                  value={newTaskData.description ? { label: newTaskData.description, value: newTaskData.description } : null}
                                  onChange={(selectedOption) => setNewTaskData({ ...newTaskData, description: selectedOption?.value || "" })}
                                />
                              </div>

                              {/* Responsible */}
                              <div className="mb-3">
                                <label className="col-form-label">Responsible</label>
                                <select
                                  className="form-control"
                                  name="responsible"
                                  value={newTaskData.responsible}
                                  onChange={handleInputChange}
                                >
                                  <option value="" disabled>Select Responsible</option>
                                  {listUserCall.map((user) => (
                                    <option key={user.uuid} value={user.uuid}>
                                      {user.username}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {/* Assign Type */}
                              <div className="row">
                                {/* Assign Type */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign Type</label>
                                  <select
                                    className="form-control"
                                    value={newTaskData.assignType}
                                    onChange={handleTaskAssignTypeChange}>
                                    <option value="">Select Assign Type</option>
                                    {selectAssignType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>

                                {/* Assign */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign</label>
                                  <Select
                                    className="select2"
                                    options={assignTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={assignTaskOptions.find(option => option.value === newTaskData.assignId) || null}
                                    onChange={(selectedOption) => setNewTaskData({ ...newTaskData, assignId: selectedOption?.value || 0 })}
                                    isDisabled={assignTaskOptions.length === 0}
                                  />
                                </div>
                              </div>

                              {/* Target Type */}
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Target Type</label>
                                  <select
                                    className="form-control"
                                    value={newTaskData.targetType}
                                    onChange={handleTaskRelatedToTypeChange}
                                  >
                                    <option value="">Select Target Type</option>
                                    {selectRelatedToType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>

                                {/* Target */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Target</label>
                                  <Select
                                    className="select2"
                                    options={relateTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={relateTaskOptions.find(option => option.value === newTaskData.targetId) || null}
                                    onChange={(selectedOption) => setNewTaskData({ ...newTaskData, targetId: selectedOption?.value || 0 })}
                                    isDisabled={relateTaskOptions.length === 0}
                                  />
                                </div>
                              </div>


                              <div className="row">
                                {/* Start Date */}
                                <div className="mb-6">
                                  <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    name="startDate"
                                    value={newTaskData.startDate}
                                    onChange={handleInputChange}
                                  />
                                </div>

                                {/* End Date */}
                                <div className="mb-6">
                                  <label className="col-form-label">End Date</label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    name="endDate"
                                    value={newTaskData.endDate}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>

                              {/* Status */}
                              <div className="mb-3">
                                <label className="col-form-label">Status <span className="text-danger">*</span></label>
                                <Select
                                  options={selectTaskStatusOptions}
                                  placeholder="Choose"
                                  classNamePrefix="react-select"
                                  value={newTaskData.status ? { label: newTaskData.status, value: newTaskData.status } : null}
                                  onChange={(selectedOption) => setNewTaskData({ ...newTaskData, status: selectedOption?.value || "" })}
                                />
                              </div>

                              {/* Priority */}
                              <div className="mb-3">
                                <label className="col-form-label">Priority</label>
                                <Select
                                  options={selectTaskPriorityOptions}
                                  placeholder="Choose"
                                  classNamePrefix="react-select"
                                  value={newTaskData.priority ? { label: newTaskData.priority, value: newTaskData.priority } : null}
                                  onChange={(selectedOption) => setNewTaskData({ ...newTaskData, priority: selectedOption?.value || "" })}
                                />
                              </div>

                              {/* Description */}
                              <div className="mb-3">
                                <label className="col-form-label">Description</label>
                                <textarea
                                  className="form-control"
                                  name="description"
                                  rows={4}
                                  value={newTaskData.description}
                                  onChange={handleInputChange}
                                />
                              </div>

                              {/* Confirm & Cancel Buttons */}
                              <div className="text-end modal-btn">
                                <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                                <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateTasks}>
                                  Confirm
                                </button>
                              </div>

                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Create Task */}
                {/*Update Task*/}
                <div className="modal custom-modal fade modal-padding" id="edit_task" role="dialog">
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Update Task</h5>
                        <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="row">
                            <div className="col-md-12">
                              {/* Title */}
                              <div className="mb-3">
                                <label className="col-form-label">Title <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="title" value={editingTask?.title || ""} onChange={handleUpdateTaskInputChange} />
                              </div>

                              {/* Category */}
                              <div className="mb-3">
                                <label className="col-form-label">Category</label>
                                <Select
                                  options={selectTaskCategoryOptions}
                                  placeholder="Choose"
                                  name="category"
                                  value={selectTaskCategoryOptions.find(opt => opt.value === editingTask?.category)}
                                  onChange={(option) => handleUpdateTaskSelectChange("category", option?.value ?? "")}
                                  classNamePrefix="react-select"
                                />
                              </div>

                              {/* Responsible */}
                              <div className="mb-3">
                                <label className="col-form-label">Responsible</label>
                                <select className="form-control" name="responsible" value={editingTask?.responsible.uuid || ""} disabled={true} onChange={handleUpdateTaskInputChange}>
                                  <option value="" disabled>Select Responsible</option>
                                  {listUserCall.map(user => (
                                    <option key={user.uuid} value={user.uuid}>{user.username}</option>
                                  ))}
                                </select>
                              </div>
                              {/* Assign Type */}
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign Type</label>
                                  <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editingTask?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                                    <option value="">Select Assign Type</option>
                                    {selectAssignType.map(option => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>

                                {/* Assign */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign</label>
                                  <Select
                                    options={assignTaskOptions}
                                    placeholder="Choose"
                                    value={assignTaskOptions.find(opt => opt.value === editingTask?.assignee?.id) || null}
                                    onChange={(option) => handleUpdateTaskSelectChange("assignId", option?.value || 0)}
                                    isDisabled={true}
                                    classNamePrefix="react-select"
                                  />
                                </div>
                              </div>

                              {/* Target Type */}
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Target Type</label>
                                  <select className="form-control" name="targetType" value={editingTask?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                                    <option value="">Select Target Type</option>
                                    {selectRelatedToType.map(option => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>

                                {/* Target ID */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Target</label>
                                  <Select
                                    options={relateTaskOptions}
                                    placeholder="Choose"
                                    value={relateTaskOptions.find(opt => opt.value === editingTask?.targets?.id) || null}
                                    onChange={(option) => handleUpdateTaskSelectChange("targetId", option?.value ?? 0)}
                                    isDisabled={relateTaskOptions.length === 0}
                                    classNamePrefix="react-select"
                                  />
                                </div>
                              </div>

                              <div className="row">
                                {/* Start Date */}
                                <div className="mb-6">
                                  <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                                  <input type="datetime-local" className="form-control" name="startDate" value={editingTask?.startDate || ""} onChange={handleUpdateTaskInputChange} />
                                </div>

                                {/* End Date */}
                                <div className="mb-6">
                                  <label className="col-form-label">End Date</label>
                                  <input type="datetime-local" className="form-control" name="endDate" value={editingTask?.endDate || ""} onChange={handleUpdateTaskInputChange} />
                                </div>
                              </div>

                              {/* Status */}
                              <div className="mb-3">
                                <label className="col-form-label">Status <span className="text-danger">*</span></label>
                                <Select options={selectTaskStatusOptions}
                                  value={selectTaskStatusOptions.find(opt => opt.value === editingTask?.status)}
                                  onChange={(option) => handleUpdateTaskSelectChange("status", option?.value || "")} />
                              </div>

                              {/* Priority */}
                              <div className="mb-3">
                                <label className="col-form-label">Priority</label>
                                <Select options={selectTaskPriorityOptions} placeholder="Choose"
                                  value={selectTaskPriorityOptions.find(opt => opt.value === editingTask?.priority)}
                                  onChange={(option) => handleUpdateTaskSelectChange("priority", option?.value || "")} classNamePrefix="react-select" />
                              </div>

                              {/* Description */}
                              <div className="mb-3">
                                <label className="col-form-label">Description</label>
                                <textarea className="form-control" rows={4} name="description" value={editingTask?.description || ""} onChange={handleUpdateTaskInputChange} />
                              </div>

                              {/* Confirm & Cancel Buttons */}
                              <div className="text-end modal-btn">
                                <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                                <button
                                  className="btn btn-primary"
                                  data-bs-dismiss="modal"
                                  type="button"
                                  onClick={() => selectedTaskId?.id && handleUpdateTask(selectedTaskId?.id)}
                                >
                                  Confirm
                                </button>
                              </div>

                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/*Update Task*/}
                {/*Event */}
                <div className="tab-pane fade" id="events">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Events</h4>
                      <div className="d-inline-flex align-items-center">
                        <button
                          className="btn btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#create_event"
                        >
                          <i className="ti ti-plus"></i> Add New Event
                        </button>
                        <div className="form-sort mt-0">
                          <i className="ti ti-sort-ascending-2" />
                          <Select
                            className="select"
                            options={ascendingandDecending}
                            placeholder="Ascending"
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {loading ? (
                        <p>Loading events...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : events.length === 0 ? (
                        <div className="text-center p-5">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-calendar-event fs-24 text-primary"></i>
                          </div>
                          <h5>No events yet</h5>
                          <p className="text-muted">Create your first event by clicking the button above</p>
                        </div>
                      ) : (
                        events.map((event) => (
                          <div key={event.id} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-success">
                                  <i className="ti ti-calendar-event text-white"></i>
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-medium mb-0">Subject : {event.subject}</h6>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          className="dropdown-item"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_event"
                                          onClick={() => handleEditClickEvent(event.id)}
                                        >
                                          <i className="ti ti-edit text-blue"></i> Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteEventClick(event.id)}
                                        >
                                          <i className="ti ti-trash text-danger"></i> Delete
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">Description: {event.description || "No description"}</p>
                                  <div className="d-flex flex-wrap gap-2 mb-1">
                                    <span className="badge bg-success">
                                      Start Time: {new Date(event.startTime).toLocaleString()}
                                    </span>
                                    <span className="badge bg-danger">
                                      End Time: {new Date(event.endTime).toLocaleString()}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>

                  </div>
                </div>
                {/*Events */}
                {/* Add Event */}
                <div
                  className="modal custom-modal fade modal-padding"
                  id="create_event"
                  role="dialog"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add New Event</h5>
                        <button
                          type="button"
                          className="btn-close position-static"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Subject <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter subject"
                                  value={newEventData.subject}
                                  onChange={(e) => setNewEventData({ ...newEventData, subject: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Description</label>
                                <textarea
                                  className="form-control"
                                  rows={4}
                                  placeholder="Enter description"
                                  value={newEventData.description}
                                  onChange={(e) => setNewEventData({ ...newEventData, description: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Location</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter location"
                                  value={newEventData.location}
                                  onChange={(e) => setNewEventData({ ...newEventData, location: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Attendees</label>
                                <Select
                                  isMulti
                                  options={attendeesOptions}
                                  value={attendees}
                                  onChange={handleSelectAttendeesChange}
                                  classNamePrefix="react-select"
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      minHeight: "50px",
                                      maxHeight: "none",
                                      flexWrap: "wrap",
                                      overflowY: "auto",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      flexWrap: "wrap",
                                      maxHeight: "150px",
                                      overflowY: "auto",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign Type</label>
                                  <select
                                    className="form-control"
                                    value={newEventData.assignType}
                                    onChange={handleTaskAssignTypeChange}>
                                    <option value="">Select Assign Type</option>
                                    {selectAssignType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign</label>
                                  <Select
                                    isMulti
                                    className="select2"
                                    options={assignTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={assignTaskOptions.filter(option =>
                                      newEventData.assigneeId && Array.isArray(newEventData.assigneeId)
                                        ? newEventData.assigneeId.includes(option.value)
                                        : false
                                    )}
                                    onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                                      setNewEventData({
                                        ...newEventData,
                                        assigneeId: selectedOptions.length > 0
                                          ? selectedOptions.map((option) => option.value)
                                          : [],
                                      })
                                    }
                                    isDisabled={assignTaskOptions.length === 0}
                                    styles={{
                                      control: (provided, state) => ({
                                        ...provided,
                                        minHeight: "50px",
                                        maxHeight: "none",
                                        flexWrap: "wrap",
                                        overflowY: "auto",
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        flexWrap: "wrap",
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Target Type</label>
                                  <select
                                    className="form-control"
                                    value={newEventData.targetType}
                                    onChange={handleTaskRelatedToTypeChange}
                                  >
                                    <option value="">Select Target Type</option>
                                    {selectRelatedToType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>
                                {/* Target */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Target</label>
                                  <Select
                                    className="select2"
                                    options={relateTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={relateTaskOptions.find(option => option.value === newEventData.targetIds) || null}
                                    onChange={(selectedOption) => setNewEventData({ ...newEventData, targetIds: selectedOption?.value || 0 })}
                                    isDisabled={relateTaskOptions.length === 0}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="col-form-label">Start Time</label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={newEventData.startTime}
                                    onChange={(e) => setNewEventData({ ...newEventData, startTime: e.target.value })}
                                  />
                                </div>
                                <div className="col-md-12">
                                  <label className="col-form-label">End Time</label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={newEventData.endTime}
                                    onChange={(e) => setNewEventData({ ...newEventData, endTime: e.target.value })}
                                  />
                                </div>
                              </div>
                              <div className="text-end modal-btn mt-3">
                                <button
                                  className="btn btn-light"
                                  data-bs-dismiss="modal"
                                  type="button"
                                >
                                  Cancel
                                </button>
                                <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateEvent}>
                                  Create
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                {/* /Add Event */}
                {/* /Update Event */}
                <div
                  className="modal custom-modal fade modal-padding"
                  id="edit_event"
                  role="dialog"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Update Event</h5>
                        <button
                          type="button"
                          className="btn-close position-static"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Subject <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter subject"
                                  value={editEventData.subject}
                                  onChange={(e) => setEditEventData({ ...editEventData, subject: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Description</label>
                                <textarea
                                  className="form-control"
                                  rows={4}
                                  placeholder="Enter description"
                                  value={editEventData.description}
                                  onChange={(e) => setEditEventData({ ...editEventData, description: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Location</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter location"
                                  value={editEventData.location}
                                  onChange={(e) => setEditEventData({ ...editEventData, location: e.target.value })}
                                />
                              </div>
                              <div className="mb-3">
                                <label className="col-form-label">Attendees</label>
                                <Select
                                  isMulti
                                  options={attendeesOptions}
                                  value={selectedAttendees}
                                  onChange={handleSelectAttendeesChange}
                                  classNamePrefix="react-select"
                                />
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Involve Type</label>
                                  <select
                                    className="form-control"
                                    value={editEventData.assignType}
                                    onChange={handleTaskAssignTypeChange}>
                                    <option value="">Select Assign Type</option>
                                    {selectAssignType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label">Assign</label>
                                  <Select
                                    isMulti
                                    className="select2"
                                    options={assignTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={assignTaskOptions.filter(option => editEventData.assigneeId.includes(option.value))}
                                    onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                                      setEditEventData({
                                        ...editEventData,
                                        assigneeId: selectedOptions.map((option) => option.value),
                                      })
                                    }
                                    isDisabled={assignTaskOptions.length === 0}
                                    styles={{
                                      control: (provided, state) => ({
                                        ...provided,
                                        minHeight: "50px",
                                        maxHeight: "auto",
                                        overflowY: "auto",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <label className="col-form-label">Target Type</label>
                                  <select
                                    className="form-control"
                                    value={editEventData?.targetType}
                                    onChange={handleTaskRelatedToTypeChange}
                                  >
                                    <option value="">Select Target Type</option>
                                    {selectRelatedToType.map((option) => (
                                      <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                  </select>
                                </div>
                                {/* Target */}
                                <div className="col-md-6">
                                  <label className="col-form-label">Target</label>
                                  <Select
                                    className="select2"
                                    options={relateTaskOptions}
                                    placeholder="Choose"
                                    classNamePrefix="react-select"
                                    value={relateTaskOptions.find(option => option.value === editEventData.targetIds)}
                                    onChange={(selectedOption) => setEditEventData({ ...editEventData, targetIds: selectedOption?.value || 0 })}
                                    isDisabled={relateTaskOptions.length === 0}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="col-form-label">Start Time</label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={editEventData.startTime}
                                    onChange={(e) => setEditEventData({ ...editEventData, startTime: e.target.value })}
                                  />
                                </div>
                                <div className="col-md-12">
                                  <label className="col-form-label">End Time</label>
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={editEventData.endTime}
                                    onChange={(e) => setEditEventData({ ...editEventData, endTime: e.target.value })}
                                  />
                                </div>
                              </div>
                              <div className="text-end modal-btn mt-3">
                                <button
                                  className="btn btn-light"
                                  data-bs-dismiss="modal"
                                  type="button"
                                >
                                  Cancel
                                </button>
                                <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleUpdateEvent}>
                                  Confirm
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Update Event */}
                {/* Files */}
                <div className="tab-pane fade" id="files">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="fw-semibold">Files</h4>
                    </div>
                    <div className="card-body">
                      <div className="card border mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Manage Documents
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3">
                                <Link
                                  to="#"
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#new_file"
                                >
                                  Create Document
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-21.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Vaughan</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-danger-light me-1">
                                  Proposal
                                </span>
                                <span className="badge bg-pending priority-badge me-1">
                                  Draft
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-01.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Jessica</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-purple-light me-1">
                                  Quote
                                </span>
                                <span className="badge bg-success me-1">
                                  Sent
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-0">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-22.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Dawn Merhca</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-danger-light me-1">
                                  Proposal
                                </span>
                                <span className="badge bg-pending priority-badge me-1">
                                  Draft
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Files */}
                {/* Email */}
                <div className="tab-pane fade" id="email">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Email</h4>
                      <div className="d-inline-flex align-items-center">
                        <OverlayTrigger
                          placement="left"
                          overlay={
                            <Tooltip id="refresh-tooltip">
                              There are no email accounts configured, Please
                              configured your email account in order to Send/
                              Create EMails
                            </Tooltip>
                          }
                        >
                          <Link to="#">
                            <i className="ti ti-circle-plus me-1" />
                            Create Email
                          </Link>
                        </OverlayTrigger>
                        {/* <Link
                        to="#"
                        className="link-purple fw-medium"
                        data-bs-toggle="tooltip"
                        data-bs-placement="left"
                        data-bs-custom-className="tooltip-dark"
                        data-bs-original-title=""
                      >
                        <i className="ti ti-circle-plus me-1" />
                        Create Email
                      </Link> */}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card border mb-0">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Manage Emails
                                </h4>
                                <p>
                                  You can send and reply to emails directly via
                                  this section.
                                </p>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3">
                                <Link
                                  to="#"
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#create_email"
                                >
                                  Connect Account
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Email */}
              </div>
              {/* /Tab Content */}
            </div>
            {/* /Deals Details */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Create Contact */}
      <div className="modal custom-modal fade" id="create_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-user-plus" />
                </div>
                <h3>Contact Created Successfully!!!</h3>
                <p>View the details of contact, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Contact */}
      {/* Add quotes */}
      {showQuoteModal && (
        <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">New Quote</h5>
                <button type="button" className="btn-close" onClick={() => setShowQuoteModal(false)} aria-label="Close" >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      <label className="col-form-label">Quote Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={quote.name}
                        onChange={handleChange}
                      />
                      {errors.quoteName && (
                        <small className="text-danger">{errors.quoteName}</small>
                      )}
                    </div>
                  </div>
                  <label className="mt-3 col-form-label">Product List</label>
                  {dealDetail?.opportunityProductResponses?.length ? (
                    <table className="table table-bordered">
                      <tr>
                        <td>Product Name</td>
                        <td style={{ textAlign: "right" }}>Price ($)</td>
                        <td style={{ textAlign: "center" }}>Quantity</td>
                        <td style={{ textAlign: "right" }}>Total Price ($)</td>
                      </tr>
                      {dealDetail.opportunityProductResponses.map((product) => (
                        <tr key={product.id}>
                          <td>{product.productName}</td>
                          <td style={{ textAlign: "right" }}>{product.salePrice.toFixed(2)}</td>
                          <td style={{ textAlign: "center" }}>{product.quantity}</td>
                          <td style={{ textAlign: "right" }}>{(product.salePrice * product.quantity).toFixed(2)}</td>
                        </tr>
                      ))}
                    </table>
                  ) : (
                    <p className="text-muted">No products available</p>
                  )}
                  <hr></hr>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="col-form-label">Discount (%)</label>
                      <input type="number" className="form-control" name="discountRate" value={quote.discountRate} onChange={handleNumberChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="col-form-label">Tax (%)</label>
                      <input type="number" className="form-control" name="taxRate" value={quote.taxRate} onChange={handleNumberChange} />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="col-form-label">Expiration Date<span className="text-danger">*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      name="expiryDate"
                      value={quote.expiryDate}
                      onChange={handleChange}
                    />
                    {errors.date && (
                      <small className="text-danger">{errors.date}</small>
                    )}
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="col-form-label">Notes</label>
                    <textarea className="form-control" rows={4} name="notes" value={quote.notes} onChange={handleChange} />
                    {errors.description && (
                      <small className="text-danger">{errors.description}</small>
                    )}
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">Subtotal:</h6>
                    <h6 className="mb-0 fw-bold">${subtotal.toFixed(2)}</h6>
                  </div>

                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">Discount ({quote.discountRate}%):</h6>
                    <h6 className="mb-0 fw-bold">- ${discountAmount.toFixed(2)}</h6>
                  </div>

                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">Tax ({quote.taxRate}%):</h6>
                    <h6 className="mb-0 fw-bold">${taxAmount.toFixed(2)}</h6>
                  </div>

                  <div className="d-flex justify-content-between">
                    <h6 className="mb-0">Total Price:</h6>
                    <h6 className="mb-0 fw-bold">${totalDealPrice.toFixed(2)}</h6>
                  </div>
                  <hr />
                  <div className="text-end modal-btn">
                    <Link to="#" className="btn btn-light" onClick={() => setShowQuoteModal(false)}>Cancel</Link>
                    <button className="btn btn-primary" type="button" onClick={handleSubmit}>Save Quote</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* /Add Quotes */}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={newLogCall.userCall}
                          disabled={true}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, userCall: e.target.value }))}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        onChange={(selected) => {
                          if (selected) {
                            setNewLogCall((prev) => ({ ...prev, status: selected.value }));
                          }
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Call Date <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={newLogCall.followUpDate}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, followUpDate: e.target.value }))}
                      />
                    </div>
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newLogCall.assignRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, assignRecord: selectedOption?.value || 0 })}
                          isDisabled={assignTaskOptions.length === 0}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newLogCall.targetRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, targetRecord: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        value={newLogCall.note}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="checkboxs">
                        <input
                          type="checkbox"
                          checked={newLogCall.checkedCreateFollowingTask}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, checkedCreateFollowingTask: e.target.checked }))}
                        />
                        <span className="checkmarks" /> Create a Follow-Up task
                      </label>
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button"
                        onClick={handleCreateLogCall}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Call Log */}

      {/* /Edit Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={editLogCall?.userCall || ""}
                          disabled={true}
                          onChange={(e) => handleSelectChange(e, "userCall")}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        name="status"
                        value={statusList.find((status) => status.value === editLogCall?.status)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder="Select date"
                          id="follow-up-date"
                          name="followUpDate"
                          value={editLogCall?.followUpDate || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editLogCall?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editLogCall?.assignRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignRecord", option?.value || 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editLogCall?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editLogCall?.targetRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetRecord", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        name="note"
                        value={editLogCall?.note || ""}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedLogCallId?.id && handleUpdateLogCall(selectedLogCallId?.id)}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={rolesOfContactRole}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Owner <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="#" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="#" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}
      {/* Connect Account */}
      <div className="modal custom-modal fade" id="create_email" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect Account</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Account type <span className="text-danger"> *</span>
                </label>
                <Select
                  className="select2"
                  options={accountType}
                  placeholder="Choose"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="mb-3">
                <h5 className="form-title">Sync emails from</h5>
                <div className="sync-radio">
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test1"
                      name="radio-group"
                      defaultChecked
                    />
                    <label htmlFor="test1">Now</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test2"
                      name="radio-group"
                    />
                    <label htmlFor="test2">1 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test3"
                      name="radio-group"
                    />
                    <label htmlFor="test3">3 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test4"
                      name="radio-group"
                    />
                    <label htmlFor="test4">6 Month Ago</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-end modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary"
                  data-bs-target="#success_mail"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                >
                  Connect Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Connect Account */}
      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with "example@example.com". Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to={route.companyDetails} className="btn btn-primary">
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}
      {/* Add Contact Role */}
      <div className="modal custom-modal fade" id="add_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Contact Roles</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2">
                  <Select
                    isMulti
                    options={contactOptions}
                    value={contactOptions.filter((option) => selectedContactRoles.includes(Number(option.value)))}
                    onChange={handleChangeContactRole}
                    placeholder="Search and select contacts..."
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    styles={customStyles}
                  />
                </div>

                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleConfirmAddContactRoles}
                    data-bs-dismiss="modal"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Contact Role*/}
      {/* Edit Contact Role*/}
      <div className="modal custom-modal fade" id="edit_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Contact Roles</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2">
                  <Select
                    isMulti
                    options={contactOptions}
                    value={contactOptions.filter((option) => selectedContactRoles.includes(Number(option.value)))}
                    onChange={handleChangeContactRole}
                    placeholder="Search and select contacts..."
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    styles={customStyles}
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleConfirmAddContactRoles}
                    data-bs-dismiss="modal"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Contact Roles */}
      {/* Edit Selected Contact Role*/}
      <div className="modal custom-modal fade" id="edit_selected_contactroles" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Contact Role</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Contact Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={selectedContactRole?.contactName || ""}
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Select Role</label>
                  <select
                    className="form-select"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                  >
                    <option value="">Choose a role</option>
                    {rolesOfContactRole.map((role) => (
                      <option key={role.value} value={role.value}>
                        {role.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="modal-btn text-end">
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleUpdateContactRole}
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Selected Contact Role */}
      {/* Choose Price Book */}
      <div className="modal custom-modal fade" id="choose_pricebook" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Choose Price Book</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <p className="text-muted">
                Select a Price Book to associate with this opportunity. You can add products only from the Price Book you associate with this opportunity. <strong>Changing the Price Book deletes all products from the opportunity.</strong>
              </p>
              <form>
                <div className="mb-2">
                  <label className="form-label">Price Book</label>
                  <Select
                    options={priceBookOptions}
                    value={selectedPriceBook}
                    onChange={handleChangePriceBook}
                    placeholder="Select a Price Book..."
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleConfirmChoosePriceBook}
                    data-bs-dismiss="modal"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Choose Price Book */}

      {/* Add Owner */}
      <div className="modal custom-modal fade" id="owner" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Deal Owner</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" defaultChecked />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-19.jpg" alt="" />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-20.jpg" alt="" />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-21.jpg" alt="" />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="" />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-16.jpg" alt="" />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-22.jpg" alt="" />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Owner */}
      {/* Deal Status */}
      <div className="modal custom-modal fade" id="deal_status" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deal Status</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    classNamePrefix="react-select"
                    options={status}
                    placeholder="Choose"
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea className="form-control" rows={5} defaultValue={""} />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Deal Status */}
      {/* Add New Pipeline */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_pipeline"
      >
        <div className="offcanvas-header border-bottom">
          <h4>Add New Pipeline</h4>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form >
            <div>
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input className="form-control" type="text" />
              </div>
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <Link
                    to="#"
                    className="add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    <i className="ti ti-square-rounded-plus" />
                    Add New
                  </Link>
                </div>
                <div className="pipeline-listing">
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Inpipeline
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Follow Up
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Schedule Service
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        onClick={() => setOpenModal(true)}
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="form-title">Access</h5>
                <div className="d-flex flex-wrap access-item nav">
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="all"
                      name="status"
                      defaultChecked
                    />
                    <label htmlFor="all">All</label>
                  </div>
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#select-person"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="select"
                      name="status"
                    />
                    <label htmlFor="select">Select Person</label>
                  </div>
                </div>
                <div className="tab-content mb-3">
                  <div className="tab-pane fade" id="select-person">
                    <div className="access-wrapper">
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt="Image"
                          />
                          Vaughan
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt="Image"
                          />
                          Jessica
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#create_pipeline"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Pipeline */}
      <Modal
        show={showAddProductModal}
        onHide={() => setShowAddProductModal(false)}
        centered
        dialogClassName="modal-dialog-centered"
        contentClassName="custom-modal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Choose Products</h5>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => setShowAddProductModal(false)}
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body">
            <p className="text-muted">Select products from the chosen Price Book.</p>

            <div className="mb-2">
              <label className="form-label">Products</label>
              <Select
                options={productOptions}
                value={selectedProducts}
                onChange={handleChangeProducts}
                isMulti
                placeholder="Select products..."
                className="react-select-container"
                classNamePrefix="react-select"
                menuPlacement="auto"
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>

            <div className="modal-btn text-end">
              <button
                className="btn btn-light me-2"
                onClick={() => setShowAddProductModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleConfirmProducts();
                  setShowAddProductModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Choose Product */}
      <div className={`modal fade ${showProductDetailModal ? "show d-block" : ""}`} role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content shadow rounded-4">
            {/* Header */}
            <div className="modal-header bg-gradient-to-r from-blue-600 to-blue-400 text-white">
              <h5 className="modal-title font-semibold">Selected Products</h5>
              <button className="btn-close btn-close-white" onClick={() => setShowProductDetailModal(false)} />
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="table-responsive max-h-[400px] overflow-y-auto">
                <table className="table table-hover align-middle">
                  <thead className="bg-blue-500 text-white">
                    <tr>
                      <th>Product Name</th>
                      <th className="text-center">Quantity</th>
                      <th className="text-center">Sale Price</th>
                      <th>Description</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProductDetails.map((product, index) => (
                      <tr key={product.productPriceBookId} className="hover:bg-gray-100">
                        <td>{product.productName}</td>
                        <td className="text-center">
                          <input
                            type="number"
                            value={product.quantity}
                            min="1"
                            className="form-control text-center w-20 border-gray-300 rounded-md"
                            onChange={(e) => {
                              const updatedProducts = [...selectedProductDetails];
                              updatedProducts[index].quantity = Number(e.target.value);
                              setSelectedProductDetails(updatedProducts);
                            }}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            value={product.salePrice}
                            className="form-control text-center w-28 border-gray-300 rounded-md"
                            onChange={(e) => {
                              const updatedProducts = [...selectedProductDetails];
                              updatedProducts[index].salePrice = parseFloat(e.target.value) || 0;
                              setSelectedProductDetails(updatedProducts);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={product.description}
                            className="form-control border-gray-300 rounded-md"
                            onChange={(e) => {
                              const updatedProducts = [...selectedProductDetails];
                              updatedProducts[index].description = e.target.value;
                              setSelectedProductDetails(updatedProducts);
                            }}
                          />
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-danger btn-sm flex items-center justify-center px-2 py-1 rounded-md hover:bg-red-600 transition"
                            onClick={() => handleRemoveProduct(index)}
                          >
                            🗑️
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer d-flex justify-content-between">
              <button className="btn btn-light" onClick={() => setShowProductDetailModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={confirmAddProductToOppotunity}>
                <i className="ti ti-check me-1"></i> Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_task"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Task?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this task?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteTask()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Create Pipeline */}
      <div className="modal custom-modal fade" id="create_pipeline" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Pipeline Created Successfully!!!</h3>
                <p>View the details of pipeline, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Pipeline*/}
      {/* Edit Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Opportunities</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Opportunity Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" name="name" value={editingDeal?.name} onChange={handleChange} />
                  {errorsEditForm.name && <small className="text-danger">{errorsEditForm.name}</small>}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  {companies.length > 0 && (
                    <Select
                      className="select2"
                      options={companies}
                      placeholder="Choose Company"
                      classNamePrefix="react-select"
                      value={companies.find(option => option.value === Number(editingDeal?.accountId)) || null}
                      onChange={(selectedOption) => handleSelectChange(selectedOption, "accountId")}
                    />
                  )}
                  {errorsEditForm.accountId && <small className="text-danger">{errorsEditForm.accountId}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Stage <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={stages}
                    placeholder="Choose Stage"
                    classNamePrefix="react-select"
                    value={stages.find(option => option.value === Number(editingDeal?.stageId)) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "stageId")}
                  />
                  {errorsEditForm.stages && <small className="text-danger">{errorsEditForm.stages}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Probability (%) <span className="text-danger"></span>
                  </label>
                  <input
                    type="number"
                    name="probability"
                    className="form-control"
                    value={editingDeal?.probability ?? ""}
                    min={0}
                    max={100}
                    step="0.001"
                    onChange={handleChange}
                  />
                  {errorsEditForm.probability && <small className="text-danger">{errorsEditForm.probability}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    name="status"
                    value={status.find(option => option.value === editingDeal?.status)}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                  />
                  {errorsEditForm.status && <small className="text-danger">{errorsEditForm.status}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Amount
                  </label>
                  <input type="number" className="form-control" name="amount" value={editingDeal?.amount} onChange={handleChange} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={editingDeal?.dueDate ? new Date(editingDeal.dueDate) : new Date()}
                      onChange={(date) =>
                        setEditingDeal((prev) => {
                          if (!prev) return prev;
                          return {
                            ...prev,
                            dueDate: date?.toISOString() || prev.dueDate,
                          };
                        })
                      }

                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Close Date
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={editingDeal?.expectedCloseDate ? new Date(editingDeal.expectedCloseDate) : new Date()}
                      onChange={(date) =>
                        setEditingDeal(prev => {
                          if (!prev) return prev; 
                          return {
                            ...prev,
                            expectedCloseDate: date?.toISOString() || prev.expectedCloseDate
                          };
                        })
                      }
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control"
                      selected={editingDeal?.followUpDate ? new Date(editingDeal.followUpDate) : new Date()}
                      onChange={(date) =>
                        setEditingDeal(prev => {
                          if (!prev) return prev; 
                          return {
                            ...prev,
                            followUpDate: date?.toISOString() || prev.followUpDate
                          };
                        })
                      }
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              {errorsEditForm.date && <small className="text-danger">{errorsEditForm.date}</small>}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Owner
                  </label>
                  <input type="text" className="form-control" name="owner" value={editingDeal?.owner} readOnly />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={source}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                    value={source.find(option => option.value === (editingDeal?.source)) || null}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, "source")}
                  />
                  {errorsEditForm.source && <small className="text-danger">{errorsEditForm.source}</small>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags
                  </label>
                  <Select
                    isMulti
                    options={allTags.map(tag => ({
                      value: tag.id,
                      label: tag.name
                    }))}
                    value={editingDeal?.tags?.map(tag => ({
                      value: tag.tagId,
                      label: tag.name
                    })) || []}
                    onChange={handleTagChange}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "50px",
                        maxHeight: "auto",
                        overflowY: "auto",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description
                  </label>
                  <DefaultEditor
                    className="summernote"
                    name="description"
                    value={editingDeal?.description}
                    onChange={handleChange}
                  />
                  {errorsEditForm.description && <small className="text-danger">{errorsEditForm.description}</small>}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdate}
              >
                Edit
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Deals */}
      <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Opportunity Updated Successfully!!!</h3>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to={`/crm/deals-details/${editedUuid}`}
                onClick={() => {
                  setOpenEditSuccessModal(false);
                }}
                className="btn btn-primary"
              >
                Ok
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}
      {/* Delete Stage */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Stage?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> stage you selected.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <Link to={route.contactList} className="btn btn-danger">
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Delete Stage */}
      {/* Delete ContactRole Modal */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Contact Role?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> this contact role?
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button className="btn btn-light me-2" onClick={() => setOpenModal(false)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDeleteClickContactRoleConfirm}>
                Yes, Remove it
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Delete Product From Opportunity Modal */}
      <Modal show={showDeleteProductFromOpportunityModal} onHide={() => setShowDeleteProductFromOpportunityModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Product From Opportunity?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> this product?
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button className="btn btn-light me-2" onClick={() => setShowDeleteProductFromOpportunityModal(false)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDeleteProductFromOpportunity}>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Edit Selected Product Modal */}
      <div className="modal custom-modal fade" id="edit_selected_product" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Product</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Quantity <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        className="form-control"
                        value={updateOpportunityProductDetailData.quantity}
                        onChange={(e) => setUpdateOpportunityProductDetailData({
                          ...updateOpportunityProductDetailData,
                          quantity: parseInt(e.target.value) || 0
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">Sale Price <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        className="form-control"
                        value={updateOpportunityProductDetailData.salePrice}
                        onChange={(e) => setUpdateOpportunityProductDetailData({
                          ...updateOpportunityProductDetailData,
                          salePrice: parseFloat(e.target.value) || 0
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={updateOpportunityProductDetailData.description}
                        onChange={(e) => setUpdateOpportunityProductDetailData({
                          ...updateOpportunityProductDetailData,
                          description: e.target.value
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-btn text-end">
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={confirmHandleUpdateOpportunityProduct}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Event ?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> this event?
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button className="btn btn-light me-2" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDeleteEventConfirm}>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* Modal Delete Log Call*/}
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_logcall"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Call Log?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this call log?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteLogCall()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Deal */}
      <div className="modal fade" id="delete_deal" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Opportunity?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> opportunity you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Yes, Delete {dealToDelete?.name}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Deal */}
      <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)} centered>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-warning-light rounded-circle mb-3">
              <i className="ti ti-alert-triangle fs-36 text-warning" />
            </div>
            <h4 className="mb-2">Missing Price Book</h4>
            <p className="mb-0">
              Please select a <strong>Price Book</strong> before adding products.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                className="btn btn-primary"
                onClick={() => setShowWarningModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Edit Selected Product Modal */}
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </>
  )
}

export default DealsDetails
